import React, { useState, useEffect } from 'react';
import {
  getBuildings, getUnits, getRentStatus,
  getPendingPayments, approvePayment, rejectPayment,
  createBuilding, createUnit, createTenant,
  updateUnit, updateTenant, deleteTenant, deleteUnit,
  sendReminder, tenantMoveOut,
  getTenantPaymentHistory, recordManualPayment,
  getBuildingArrears, getTenantArrears, remindAllArrears, getTenants,
  getDepositPayments, recordDepositPayment, deleteDepositPayment,
  downloadRentReport
} from '../services/api';
import AgreementGenerator from '../components/AgreementGenerator';
import MyAgreements from '../components/MyAgreements';

const DB_STYLES = `
  @import url('https://fonts.googleapis.com/css2?family=Plus+Jakarta+Sans:wght@400;500;600;700;800&family=Inter:wght@300;400;500;600&display=swap');
  * { box-sizing: border-box; }
  .db-root { display: flex; min-height: 100vh; font-family: 'Inter', sans-serif; background: #f1f5f9; }

  /* SIDEBAR */
  .db-sidebar {
    width: 240px; flex-shrink: 0;
    background: #1f4e79;
    display: flex; flex-direction: column;
    position: fixed; top: 0; left: 0; bottom: 0; z-index: 200;
    overflow-y: auto;
  }
  .sb-logo-wrap { padding: 32px 24px 24px; border-bottom: 1px solid rgba(255,255,255,0.08); display: flex; flex-direction: column; align-items: flex-start;}
  .sb-logo-img { height: 100px; width: auto; object-fit: contain; filter: none !important; }
  .sb-logo-pill {
    display: inline-block; margin-top: 12px;
    font-size: 10px; font-weight: 700; letter-spacing: 1.2px; text-transform: uppercase;
    color: #f26522; background: rgba(242,101,34,0.12);
    border: 1px solid rgba(242,101,34,0.25); padding: 3px 10px; border-radius: 10px;
  }
  .sb-section-label {
    padding: 16px 20px 6px;
    font-size: 10px; font-weight: 600; color: rgba(255,255,255,0.35);
    text-transform: uppercase; letter-spacing: 1.5px;
  }
  .sb-item {
    display: flex; align-items: center; gap: 10px;
    padding: 9px 12px; margin: 1px 8px; border-radius: 8px;
    cursor: pointer; font-size: 13px; color: rgba(255,255,255,0.60);
    border: none; background: none; width: calc(100% - 16px); text-align: left;
    transition: all 0.15s;
  }
  .sb-item:hover { background: rgba(255,255,255,0.08); color: #fff; }
  .sb-item.active { background: rgba(242,101,34,0.18); color: #fff; border: 1px solid rgba(242,101,34,0.25); }
  .sb-dot { width: 6px; height: 6px; border-radius: 50%; background: rgba(255,255,255,0.25); flex-shrink: 0; }
  .sb-item.active .sb-dot { background: #f26522; }
  .sb-badge {
    margin-left: auto; font-size: 10px; font-weight: 600;
    padding: 1px 7px; border-radius: 10px; color: #fff;
  }
  .sb-badge.red { background: #ef4444; }
  .sb-badge.amber { background: #f59e0b; }
  .sb-bottom {
    margin-top: auto; padding: 16px 12px;
    border-top: 1px solid rgba(255,255,255,0.08);
  }
  .sb-user { display: flex; align-items: center; gap: 10px; }
  .sb-avatar {
    width: 32px; height: 32px; border-radius: 50%; flex-shrink: 0;
    background: linear-gradient(135deg, #f26522, #e05a1a);
    display: flex; align-items: center; justify-content: center;
    font-size: 13px; font-weight: 600; color: #fff;
    font-family: 'Plus Jakarta Sans', sans-serif;
  }
  .sb-user-name { font-size: 13px; font-weight: 500; color: rgba(255,255,255,0.85); }
  .sb-user-role { font-size: 11px; color: rgba(255,255,255,0.35); }
  .sb-logout-btn {
    margin-left: auto; font-size: 11px; color: rgba(255,255,255,0.35);
    background: none; border: 1px solid rgba(255,255,255,0.12);
    padding: 4px 8px; border-radius: 6px; cursor: pointer;
  }
  .sb-logout-btn:hover { color: #fff; border-color: rgba(255,255,255,0.30); }

  /* MAIN */
  .db-main { margin-left: 240px; flex: 1; display: flex; flex-direction: column; min-height: 100vh; }

  /* TOPBAR */
  .db-topbar {
    background: #fff; border-bottom: 1px solid rgba(31,78,121,0.08);
    padding: 0 28px; height: 64px;
    display: flex; align-items: center; justify-content: space-between;
    position: sticky; top: 0; z-index: 100;
    box-shadow: 0 2px 12px rgba(31,78,121,0.05);
  }
  .topbar-title { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 16px; font-weight: 700; color: #0f172a; }
  .topbar-sub { font-size: 12px; color: #64748b; margin-top: 1px; }
  .topbar-right { display: flex; align-items: center; gap: 10px; }
  .referral-chip {
    display: flex; align-items: center; gap: 6px;
    background: #f8fafc; border: 1px solid #e2e8f0;
    padding: 5px 12px; border-radius: 20px;
    font-size: 11px; color: #64748b;
  }
  .referral-code { font-weight: 700; color: #f26522; letter-spacing: 1.5px; font-family: monospace; }
  .btn-topbar {
    font-size: 12px; font-weight: 500; padding: 7px 14px;
    border-radius: 8px; border: 1px solid #e2e8f0;
    background: #fff; color: #64748b; cursor: pointer; transition: all 0.15s;
  }
  .btn-topbar:hover { background: #f8fafc; }
  .btn-topbar.orange { background: #f26522; color: #fff; border-color: #f26522; font-weight: 600; }
  .btn-topbar.orange:hover { background: #e05a1a; }

  /* CONTENT */
  .db-content { padding: 24px 28px; flex: 1; }

  /* STAT CARDS */
  .stat-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 14px; margin-bottom: 22px; }
  .stat-card {
    background: #fff; border-radius: 14px;
    border: 1px solid rgba(31,78,121,0.08); padding: 18px 20px;
    position: relative; overflow: hidden;
    box-shadow: 0 2px 8px rgba(31,78,121,0.04);
  }
  .stat-card::before { content: ''; position: absolute; top: 0; left: 0; right: 0; height: 3px; }
  .stat-card.navy::before { background: #1f4e79; }
  .stat-card.green::before { background: #16a34a; }
  .stat-card.red::before { background: #ef4444; }
  .stat-card.orange::before { background: #f26522; }
  .stat-lbl { font-size: 11px; font-weight: 600; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.8px; margin-bottom: 8px; }
  .stat-val { font-family: 'Plus Jakarta Sans', sans-serif; font-size: 30px; font-weight: 800; letter-spacing: -1px; line-height: 1; color: #0f172a; }
  .stat-val.green { color: #16a34a; }
  .stat-val.red { color: #ef4444; }
  .stat-val.orange { color: #f26522; }
  .stat-sub { font-size: 11px; color: #94a3b8; margin-top: 5px; }

  /* BUILDING PILLS */
  .bldg-row { display: flex; align-items: center; gap: 8px; margin-bottom: 16px; flex-wrap: wrap; }
  .bldg-pill {
    font-size: 12px; font-weight: 500; padding: 6px 14px; border-radius: 20px;
    border: 1px solid #e2e8f0; background: #fff; color: #374151; cursor: pointer;
    transition: all 0.15s;
  }
  .bldg-pill:hover { border-color: #1f4e79; color: #1f4e79; }
  .bldg-pill.active { background: #1f4e79; color: #fff; border-color: #1f4e79; }
  .bldg-add {
    font-size: 12px; padding: 6px 14px; border-radius: 20px;
    border: 1px dashed rgba(31,78,121,0.30); background: transparent;
    color: #64748b; cursor: pointer;
  }
  .bldg-add:hover { border-color: #1f4e79; color: #1f4e79; }

  /* TABS */
  .tab-row { display: flex; border-bottom: 1px solid #e2e8f0; margin-bottom: 18px; }
  .tab-btn {
    font-size: 13px; font-weight: 500; padding: 10px 18px;
    border: none; background: none; cursor: pointer; color: #64748b;
    border-bottom: 2px solid transparent; margin-bottom: -1px;
    display: flex; align-items: center; gap: 6px; transition: all 0.15s;
  }
  .tab-btn:hover { color: #1f4e79; }
  .tab-btn.active { color: #1f4e79; border-bottom-color: #1f4e79; font-weight: 700; }
  .tab-badge {
    display: inline-flex; align-items: center; justify-content: center;
    width: 18px; height: 18px; border-radius: 50%;
    font-size: 10px; font-weight: 700; color: #fff;
  }
  .tab-badge.red { background: #ef4444; }
  .tab-badge.amber { background: #f59e0b; }

  /* TABLE */
  .tbl-wrap {
    background: #fff; border-radius: 14px;
    border: 1px solid rgba(31,78,121,0.08);
    overflow: hidden; box-shadow: 0 2px 8px rgba(31,78,121,0.04);
  }
  .tbl-head {
    display: grid; grid-template-columns: 2fr 1fr 1fr 1fr 120px;
    padding: 10px 18px; background: #f8fafc;
    border-bottom: 1px solid #e2e8f0;
  }
  .tbl-head span { font-size: 11px; font-weight: 600; color: #94a3b8; text-transform: uppercase; letter-spacing: 0.8px; }
  .tbl-row {
    display: grid; grid-template-columns: 2fr 1fr 1fr 1fr 120px;
    padding: 12px 18px; border-bottom: 1px solid #f1f5f9;
    align-items: center; transition: background 0.1s;
  }
  .tbl-row:last-child { border-bottom: none; }
  .tbl-row:hover { background: #fafafa; }
  .t-name { font-size: 13px; font-weight: 600; color: #0f172a; }
  .t-unit { font-size: 11px; color: #94a3b8; margin-top: 1px; }
  .t-cell { font-size: 13px; color: #374151; }
  .t-cell.muted { color: #94a3b8; font-size: 12px; }
  .status-pill { display: inline-block; font-size: 11px; font-weight: 600; padding: 3px 10px; border-radius: 20px; }
  .status-pill.paid { background: #dcfce7; color: #166534; }
  .status-pill.unpaid { background: #fee2e2; color: #991b1b; }
  .status-pill.upcoming { background: #dbeafe; color: #1e40af; }
  .act-row { display: flex; gap: 5px; flex-wrap: wrap; }
  .act-btn { font-size: 11px; padding: 4px 9px; border-radius: 6px; border: 1px solid #e2e8f0; background: #fff; color: #64748b; cursor: pointer; transition: all 0.15s; }
  .act-btn:hover { background: #f8fafc; }
  .act-btn.remind { background: #fef9c3; color: #854d0e; border-color: #fde68a; }
  .act-btn.record { background: #dbeafe; color: #1e40af; border-color: #bfdbfe; }
  .act-btn.approve { background: #dcfce7; color: #166534; border-color: #bbf7d0; }
  .act-btn.reject { background: #fee2e2; color: #991b1b; border-color: #fca5a5; }

  /* CARDS */
  .content-card {
    background: #fff; border-radius: 14px;
    border: 1px solid rgba(31,78,121,0.08); padding: 20px 22px;
    margin-bottom: 12px; box-shadow: 0 2px 8px rgba(31,78,121,0.04);
  }

  /* SUCCESS TOAST */
  .toast {
    position: fixed; top: 16px; right: 16px; z-index: 2000;
    background: #166534; color: #fff; padding: 12px 20px;
    border-radius: 10px; font-size: 13px; font-weight: 500;
    box-shadow: 0 4px 20px rgba(0,0,0,0.15);
  }

  /* RESPONSIVE */
  @media (max-width: 900px) {
    .db-sidebar { width: 200px; }
    .db-main { margin-left: 200px; }
    .stat-grid { grid-template-columns: repeat(2, 1fr); }
  }
  @media (max-width: 640px) {
    .db-sidebar { display: none; }
    .db-main { margin-left: 0; }
    .stat-grid { grid-template-columns: repeat(2,1fr); gap: 10px; }
    .stat-card { padding: 12px 14px; }
    .stat-num { font-size: 24px; }
    .stat-lbl { font-size: 10px; }
    .db-topbar { display: none; }
    .db-content { padding: 12px 14px; }
    .tbl-wrap { border-radius: 10px; }
    .tbl-head { display: none; }
    .tbl-row { grid-template-columns: 1fr; padding: 12px 14px; gap: 6px; }
    .content-card { padding: 14px 16px; }
    .section-inner { max-width: 100%; }
  }

  /* ── MOBILE TOP NAV ── */
  .mob-nav {
    display: none;
    background: #1f4e79;
    height: 60px; padding: 0 14px;
    align-items: center; justify-content: space-between;
    position: sticky; top: 0; z-index: 200;
    box-shadow: 0 2px 12px rgba(0,0,0,0.20);
  }
  .mob-nav-logo {
    height: 42px; width: auto;
    object-fit: contain;
  }
  .mob-nav-right { display: flex; align-items: center; gap: 8px; }
  .mob-logout-btn {
    font-size: 11px; font-weight: 600; color: #fff;
    background: rgba(255,255,255,0.15);
    border: 1px solid rgba(255,255,255,0.25);
    padding: 6px 12px; border-radius: 7px; cursor: pointer;
    font-family: 'Inter', sans-serif;
  }
  .mob-hamburger {
    font-size: 22px; color: #fff; background: none;
    border: none; cursor: pointer; padding: 2px 4px; line-height: 1;
  }
  @media (max-width: 640px) {
    .mob-nav { display: flex; }
  }

  /* ── MOBILE HORIZONTAL TABS ── */
  .mob-tab-bar {
    display: none;
    background: #fff;
    border-bottom: 1px solid #e2e8f0;
    overflow-x: auto; -webkit-overflow-scrolling: touch;
    padding: 0 8px;
    position: sticky; top: 60px; z-index: 190;
    scrollbar-width: none;
  }
  .mob-tab-bar::-webkit-scrollbar { display: none; }
  .mob-tab-bar-inner { display: flex; white-space: nowrap; }
  .mob-tab-btn {
    flex-shrink: 0; padding: 10px 14px;
    font-size: 12px; font-weight: 500; color: #94a3b8;
    border: none; background: none; cursor: pointer;
    border-bottom: 2px solid transparent;
    display: flex; align-items: center; gap: 4px;
    font-family: 'Inter', sans-serif;
  }
  .mob-tab-btn.active { color: #1f4e79; border-bottom-color: #1f4e79; font-weight: 700; }
  .mob-tab-badge {
    display: inline-flex; align-items: center; justify-content: center;
    width: 16px; height: 16px; border-radius: 50%;
    font-size: 9px; font-weight: 700; color: #fff;
  }
  .mob-tab-badge.red { background: #ef4444; }
  .mob-tab-badge.amber { background: #f59e0b; }
  @media (max-width: 640px) {
    .mob-tab-bar { display: block; }
  }

  /* ── MOBILE DRAWER ── */
  .mob-overlay {
    position: fixed; inset: 0;
    background: rgba(0,0,0,0.55);
    z-index: 300;
    opacity: 0; pointer-events: none;
    transition: opacity 0.25s ease;
  }
  .mob-overlay.open { opacity: 1; pointer-events: all; }
  .mob-drawer {
    position: fixed; top: 0; left: -280px; bottom: 0;
    width: 260px; background: #1f4e79;
    z-index: 400;
    transition: left 0.3s cubic-bezier(0.4,0,0.2,1);
    display: flex; flex-direction: column;
    overflow-y: auto;
  }
  .mob-drawer.open { left: 0; }
  .mob-drawer-head {
    padding: 16px 14px 14px;
    border-bottom: 1px solid rgba(255,255,255,0.10);
    display: flex; align-items: center; justify-content: space-between;
  }
  .mob-drawer-logo {
    height: 44px; width: auto;
    object-fit: contain;
  }
  .mob-drawer-close {
    color: rgba(255,255,255,0.55); background: none;
    border: none; font-size: 20px; cursor: pointer; padding: 4px;
  }

  /* ── MOBILE TENANT CARD (replaces table row on mobile) ── */
  @media (max-width: 640px) {
    .tbl-row { display: block; background: #fff; border-radius: 10px; margin-bottom: 8px; border: 1px solid rgba(31,78,121,0.08); }
    .tbl-row > div { display: inline; }
    .tbl-row > div:first-child { display: block; margin-bottom: 6px; }
  }
`;

const inputStyle = {
  width: '100%', padding: '10px 12px',
  border: '1.5px solid #e2e8f0', borderRadius: 7,
  fontSize: 14, boxSizing: 'border-box',
  fontFamily: 'inherit'
};

function Field({ label, children }) {
  return (
    <div style={{ marginBottom: 14 }}>
      <label style={{
        display: 'block', marginBottom: 5,
        fontSize: 13, fontWeight: 500, color: '#374151'
      }}>{label}</label>
      {children}
    </div>
  );
}

function Modal({ title, onClose, onSave, saveLabel, formError, formLoading, children }) {
  return (
    <div style={{
      position: 'fixed', inset: 0,
      background: 'rgba(0,0,0,0.4)',
      display: 'flex', alignItems: 'center',
      justifyContent: 'center', zIndex: 1000, padding: 20
    }}>
      <div style={{
        background: 'white', borderRadius: 12,
        padding: 28, width: '100%', maxWidth: 440,
        boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
        maxHeight: '90vh', overflowY: 'auto'
      }}>
        <div style={{
          display: 'flex', justifyContent: 'space-between',
          alignItems: 'center', marginBottom: 24
        }}>
          <h3 style={{ fontSize: 17, fontWeight: 600 }}>{title}</h3>
          <button onClick={onClose} style={{
            background: 'none', border: 'none',
            fontSize: 20, cursor: 'pointer', color: '#94a3b8'
          }}>✕</button>
        </div>
        {children}
        {formError && (
          <p style={{ color: '#dc2626', fontSize: 13, marginTop: 12 }}>
            {formError}
          </p>
        )}
        <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
          <button onClick={onClose} style={{
            flex: 1, padding: 11, background: '#f1f5f9',
            border: 'none', borderRadius: 8, fontSize: 14,
            cursor: 'pointer', color: '#64748b'
          }}>Cancel</button>
          <button onClick={onSave} disabled={formLoading} style={{
            flex: 2, padding: 11,
            background: formLoading ? '#cbd5e1' : '#1f4e79',
            color: 'white', border: 'none', borderRadius: 8,
            fontSize: 14, fontWeight: 600, cursor: 'pointer'
          }}>
            {formLoading ? 'Saving...' : saveLabel}
          </button>
        </div>
      </div>
    </div>
  );
}

export default function Dashboard({ user, onLogout }) {
  const [buildings, setBuildings] = useState([]);
  const [mobDrawerOpen, setMobDrawerOpen] = useState(false);
  const [rentStatus, setRentStatus] = useState(null);
  const [pending, setPending] = useState([]);
  const [selectedBuilding, setSelectedBuilding] = useState(null);
  const [activeTab, setActiveTab] = useState('overview');
  const [loading, setLoading] = useState(true);
  const [actionLoading, setActionLoading] = useState(null);
  const [units, setUnits] = useState([]);

  // Referral code — passed in via user prop immediately on login/register
  const [referralCode] = useState(user.referral_code || '');
  const [referralCopied, setReferralCopied] = useState(false);

  const [showAddBuilding, setShowAddBuilding] = useState(false);
  const [showAddUnit, setShowAddUnit] = useState(false);
  const [showAddTenant, setShowAddTenant] = useState(false);
  const [showEditTenant, setShowEditTenant] = useState(false);
  const [showDeleteTenant, setShowDeleteTenant] = useState(false);
  const [showDeleteUnit, setShowDeleteUnit] = useState(false);
  const [showEditUnit, setShowEditUnit] = useState(false);
  const [showManualPayment, setShowManualPayment] = useState(false);
  const [showHistory, setShowHistory] = useState(false);
  const [showKyc, setShowKyc] = useState(false);
  const [selectedTenantForKyc, setSelectedTenantForKyc] = useState(null);
  const [kycUrls, setKycUrls] = useState(null);
  const [kycUploading, setKycUploading] = useState(false);
  const [kycError, setKycError] = useState('');
  const [showDownloadModal, setShowDownloadModal] = useState(false);
  const [downloadType, setDownloadType] = useState('month');
  const [downloadMonth, setDownloadMonth] = useState('04');
  const [downloadYear, setDownloadYear] = useState('2026');
  const [downloadFromMonth, setDownloadFromMonth] = useState('2026-01');
  const [downloadToMonth, setDownloadToMonth] = useState('2026-04');
  const [showMoveOut, setShowMoveOut] = useState(false);
  const [showDepositModal, setShowDepositModal] = useState(false);
  const [selectedTenantForDeposit, setSelectedTenantForDeposit] = useState(null);
  const [depositHistory, setDepositHistory] = useState(null);
  const [depositInstalment, setDepositInstalment] = useState('');
  const [depositDate, setDepositDate] = useState('');
  const [depositMode, setDepositMode] = useState('Cash');
  const [depositRef, setDepositRef] = useState('');
  const [depositNote, setDepositNote] = useState('');
  // Pro-rata state
  const [prorataDismissed, setProrataDismissed] = useState({}); // { tenantId: true }
  const [showProrataModal, setShowProrataModal] = useState(false);
  const [prorataData, setProrataData] = useState(null); // { tenant, unit, days, amount, month }
  const [depositLoading, setDepositLoading] = useState(false);
  const [depositError, setDepositError] = useState('');

  const [selectedUnitForTenant, setSelectedUnitForTenant] = useState(null);
  const [selectedUnitForEdit, setSelectedUnitForEdit] = useState(null);
  const [selectedUnitForDelete, setSelectedUnitForDelete] = useState(null);
  const [selectedTenantForEdit, setSelectedTenantForEdit] = useState(null);
  const [selectedTenantForDelete, setSelectedTenantForDelete] = useState(null);
  const [selectedTenantForPayment, setSelectedTenantForPayment] = useState(null);
  const [selectedTenantForHistory, setSelectedTenantForHistory] = useState(null);
  const [selectedTenantForMoveOut, setSelectedTenantForMoveOut] = useState(null);
  const [paymentHistory, setPaymentHistory] = useState([]);

  const [buildingName, setBuildingName] = useState('');
  const [buildingAddress, setBuildingAddress] = useState('');
  const [buildingUpiId, setBuildingUpiId] = useState('');
  const [editBuildingUpiId, setEditBuildingUpiId] = useState('');
  const [savingUpiId, setSavingUpiId] = useState(false);
  const [showEditBuilding, setShowEditBuilding] = useState(false);
  const [showDeleteBuilding, setShowDeleteBuilding] = useState(false);
  const [editBuildingName, setEditBuildingName] = useState('');
  const [editBuildingAddress, setEditBuildingAddress] = useState('');
  const [unitNumber, setUnitNumber] = useState('');
  const [unitFloor, setUnitFloor] = useState('');
  const [unitRent, setUnitRent] = useState('');
  const [unitType, setUnitType] = useState('rental');
  const [leaseAmount, setLeaseAmount] = useState('');
  const [tenantName, setTenantName] = useState('');
  const [tenantPhone, setTenantPhone] = useState('');
  const [tenantEmail, setTenantEmail] = useState('');       // NEW
  const [tenantAadhaar, setTenantAadhaar] = useState('');   // NEW
  const [tenantDeposit, setTenantDeposit] = useState('');
  const [tenantMoveIn, setTenantMoveIn] = useState('');
  const [manualAmount, setManualAmount] = useState('');
  const [manualDate, setManualDate] = useState('');
  const [manualMode, setManualMode] = useState('Cash');
  const [manualRef, setManualRef] = useState('');
  const [manualMonth, setManualMonth] = useState('');
  const [moveOutDepositRefunded, setMoveOutDepositRefunded] = useState(false);
  const [moveOutRefundAmount, setMoveOutRefundAmount] = useState('');

  const [formLoading, setFormLoading] = useState(false);
  const [formError, setFormError] = useState('');
  const [successMsg, setSuccessMsg] = useState('');

  const [recentMoveouts, setRecentMoveouts] = useState([]);
  const [arrearsData, setArrearsData] = useState(null);
  const [arrearsLoading, setArrearsLoading] = useState(false);
  const [showTenantArrears, setShowTenantArrears] = useState(false);
  const [, setSelectedTenantArrears] = useState(null);
  const [tenantArrearsDetail, setTenantArrearsDetail] = useState(null);

  const now = new Date();
  const currentMonth = now.toLocaleString('default', { month: 'long' }) + '-' + now.getFullYear();

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => { loadData(); }, []);

  async function loadData() {
    setLoading(true);
    try {
      const [bRes, pRes] = await Promise.all([getBuildings(), getPendingPayments()]);
      setBuildings(bRes.data);
      setPending(pRes.data);
      if (bRes.data.length > 0) {
        const first = bRes.data[0];
        setSelectedBuilding(first);
        const [sRes, uRes, aRes, tRes] = await Promise.all([
          getRentStatus(first.id, currentMonth),
          getUnits(first.id),
          getBuildingArrears(first.id),
          getTenants()
        ]);
        setRentStatus(sRes.data);
        setUnits(uRes.data);
        setArrearsData(aRes.data);
        setRecentMoveouts(tRes.data.recent_moveouts || []);
      }
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  }

  async function loadBuilding(building) {
    setSelectedBuilding(building);
    setEditBuildingUpiId(building.upi_id || '');
    try {
      const [sRes, uRes, aRes, tRes] = await Promise.all([
        getRentStatus(building.id, currentMonth),
        getUnits(building.id),
        getBuildingArrears(building.id),
        getTenants()
      ]);
      setRentStatus(sRes.data);
      setUnits(uRes.data);
      setArrearsData(aRes.data);
      setRecentMoveouts(tRes.data.recent_moveouts || []);
    } catch (err) { console.error(err); }
  }

  function resetForms() {
    setBuildingName(''); setBuildingAddress(''); setBuildingUpiId('');
    setUnitNumber(''); setUnitFloor(''); setUnitRent('');
    setUnitType('rental'); setLeaseAmount('');
    setTenantName(''); setTenantPhone('');
    setTenantEmail(''); setTenantAadhaar('');   // NEW
    setTenantDeposit(''); setTenantMoveIn('');
    setManualAmount(''); setManualDate('');
    setManualMode('Cash'); setManualRef('');
    setManualMonth(currentMonth);
    setMoveOutDepositRefunded(false);
    setMoveOutRefundAmount('');
    setDepositInstalment('');
    setDepositDate('');
    setDepositMode('Cash');
    setDepositRef('');
    setDepositNote('');
    setDepositError('');
    setFormError(''); setFormLoading(false);
  }

  function showSuccess(msg) {
    setSuccessMsg(msg);
    setTimeout(() => setSuccessMsg(''), 4000);
  }

  // Safely extract a string from FastAPI error responses.
  // detail can be a string OR an array of Pydantic validation objects.
  function parseApiError(err, fallback) {
    const detail = err.response?.data?.detail;
    if (!detail) return fallback;
    if (typeof detail === 'string') return detail;
    if (Array.isArray(detail)) {
      return detail.map(d => d.msg || JSON.stringify(d)).join(', ');
    }
    if (typeof detail === 'object') return detail.msg || JSON.stringify(detail);
    return String(detail);
  }

  function handleCopyReferral() {
    const link = `https://hashvi.in/register?ref=${referralCode}`;
    navigator.clipboard.writeText(link).then(() => {
      setReferralCopied(true);
      setTimeout(() => setReferralCopied(false), 2500);
    });
  }

  async function handleAddBuilding() {
    if (!buildingName.trim()) { setFormError('Enter building name'); return; }
    if (!buildingAddress.trim()) { setFormError('Enter address'); return; }
    setFormLoading(true); setFormError('');
    try {
      await createBuilding({
        name: buildingName.trim(),
        address: buildingAddress.trim(),
        landlord_id: user.id,
        upi_id: buildingUpiId.trim() || null
      });
      setShowAddBuilding(false); resetForms();
      await loadData();
      showSuccess('Building added successfully');
    } catch (err) {
      setFormError(parseApiError(err, 'Failed to save'));
    } finally { setFormLoading(false); }
  }

  async function handleSaveUpiId() {
    if (!selectedBuilding) return;
    setSavingUpiId(true);
    try {
      await fetch(`${process.env.REACT_APP_API_URL}/buildings/${selectedBuilding.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('hashvi_token')}`
        },
        body: JSON.stringify({
          name: selectedBuilding.name,
          address: selectedBuilding.address,
          landlord_id: user.id,
          upi_id: editBuildingUpiId.trim() || null
        })
      });
      await loadData();
      showSuccess('UPI ID saved — reminders will now include payment link');
    } catch (err) {
      console.error(err);
    } finally { setSavingUpiId(false); }
  }

  async function handleUpdateBuilding() {
    if (!editBuildingName.trim()) { setFormError('Enter building name'); return; }
    if (!editBuildingAddress.trim()) { setFormError('Enter address'); return; }
    setFormLoading(true); setFormError('');
    try {
      await fetch(`${process.env.REACT_APP_API_URL}/buildings/${selectedBuilding.id}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${localStorage.getItem('hashvi_token')}`
        },
        body: JSON.stringify({
          name: editBuildingName.trim(),
          address: editBuildingAddress.trim(),
          landlord_id: user.id,
          upi_id: editBuildingUpiId.trim() || null
        })
      });
      setShowEditBuilding(false);
      await loadData();
      showSuccess('Building updated successfully');
    } catch (err) {
      setFormError(parseApiError(err, 'Failed to update building'));
    } finally { setFormLoading(false); }
  }

  async function handleDeleteBuilding() {
    setFormLoading(true); setFormError('');
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/buildings/${selectedBuilding.id}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('hashvi_token')}` }
      });
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.detail || 'Failed to delete building');
      }
      setShowDeleteBuilding(false);
      setSelectedBuilding(null);
      setRentStatus(null);
      setUnits([]);
      await loadData();
      showSuccess('Building deleted successfully');
    } catch (err) {
      setFormError(err.message || 'Failed to delete building');
    } finally { setFormLoading(false); }
  }

  async function handleAddUnit() {
    if (!unitNumber.trim()) { setFormError('Enter unit number'); return; }
    if (!unitRent || isNaN(unitRent)) { setFormError('Enter valid monthly amount'); return; }
    setFormLoading(true); setFormError('');
    try {
      await createUnit({
        unit_number: unitNumber.trim(),
        floor: unitFloor ? parseInt(unitFloor) : null,
        rent_amount: parseFloat(unitRent),
        building_id: selectedBuilding.id,
        unit_type: unitType,
        lease_amount: unitType === 'lease' && leaseAmount ? parseFloat(leaseAmount) : null
      });
      setShowAddUnit(false); resetForms();
      await loadBuilding(selectedBuilding);
      showSuccess('Unit added successfully');
    } catch (err) {
      setFormError(parseApiError(err, 'Failed to save'));
    } finally { setFormLoading(false); }
  }

  async function handleEditUnit() {
    if (!unitNumber.trim()) { setFormError('Enter unit number'); return; }
    if (!unitRent || isNaN(unitRent)) { setFormError('Enter valid monthly amount'); return; }
    setFormLoading(true); setFormError('');
    try {
      await updateUnit(selectedUnitForEdit.id, {
        unit_number: unitNumber.trim(),
        floor: unitFloor ? parseInt(unitFloor) : null,
        rent_amount: parseFloat(unitRent),
        building_id: selectedBuilding.id,
        unit_type: unitType,
        lease_amount: unitType === 'lease' && leaseAmount ? parseFloat(leaseAmount) : null
      });
      setShowEditUnit(false); resetForms();
      await loadBuilding(selectedBuilding);
      showSuccess('Unit updated. Tenant notified on WhatsApp if rent changed.');
    } catch (err) {
      setFormError(parseApiError(err, 'Failed to update'));
    } finally { setFormLoading(false); }
  }

  async function handleAddTenant() {
    if (!tenantName.trim()) { setFormError('Enter tenant name'); return; }
    if (tenantPhone.length !== 10) { setFormError('Enter valid 10-digit phone'); return; }
    if (tenantAadhaar && tenantAadhaar.length !== 4) { setFormError('Aadhaar must be last 4 digits'); return; }
    setFormLoading(true); setFormError('');
    try {
      await createTenant({
        name: tenantName.trim(),
        phone: tenantPhone,
        email: tenantEmail.trim() || null,
        aadhaar_last4: tenantAadhaar || null,
        unit_id: selectedUnitForTenant.id,
        deposit_amount: tenantDeposit ? parseFloat(tenantDeposit) : null,
        move_in_date: tenantMoveIn || null
      });
      setShowAddTenant(false); resetForms();
      await loadBuilding(selectedBuilding);
      showSuccess('Tenant added. Welcome message sent on WhatsApp.');
    } catch (err) {
      setFormError(parseApiError(err, 'Failed to save'));
    } finally { setFormLoading(false); }
  }

  async function handleEditTenant() {
    if (!tenantName.trim()) { setFormError('Enter tenant name'); return; }
    if (tenantPhone.length !== 10) { setFormError('Enter valid 10-digit phone'); return; }
    if (tenantAadhaar && tenantAadhaar.length !== 4) { setFormError('Aadhaar must be last 4 digits'); return; }
    setFormLoading(true); setFormError('');
    try {
      await updateTenant(selectedTenantForEdit.id, {
        name: tenantName.trim(),
        phone: tenantPhone,
        email: tenantEmail.trim() || null,
        aadhaar_last4: tenantAadhaar || null,
        unit_id: selectedTenantForEdit.unit_id,  // injected when Edit modal opens
        deposit_amount: tenantDeposit ? parseFloat(tenantDeposit) : null,
        move_in_date: tenantMoveIn || null
      });
      setShowEditTenant(false); resetForms();
      await loadBuilding(selectedBuilding);
      showSuccess('Tenant details updated successfully.');
    } catch (err) {
      setFormError(parseApiError(err, 'Failed to update'));
    } finally { setFormLoading(false); }
  }

  async function handleDeleteTenant() {
    setFormLoading(true); setFormError('');
    try {
      await deleteTenant(selectedTenantForDelete.id);
      setShowDeleteTenant(false); resetForms();
      await loadBuilding(selectedBuilding);
      showSuccess(selectedTenantForDelete.name + ' deleted successfully.');
    } catch (err) {
      setFormError(parseApiError(err, 'Failed to delete'));
    } finally { setFormLoading(false); }
  }

  async function handleDeleteUnit() {
    setFormLoading(true); setFormError('');
    try {
      await deleteUnit(selectedUnitForDelete.id);
      setShowDeleteUnit(false); resetForms();
      await loadBuilding(selectedBuilding);
      showSuccess('Unit ' + selectedUnitForDelete.unit_number + ' deleted successfully.');
    } catch (err) {
      setFormError(parseApiError(err, 'Failed to delete'));
    } finally { setFormLoading(false); }
  }

  async function handleManualPayment() {
    if (!manualAmount || isNaN(manualAmount)) { setFormError('Enter valid amount'); return; }
    if (!manualDate) { setFormError('Select payment date'); return; }
    if (!manualMonth) { setFormError('Enter month'); return; }
    setFormLoading(true); setFormError('');
    try {
      await recordManualPayment({
        tenant_id: selectedTenantForPayment.id,
        amount: parseFloat(manualAmount),
        payment_date: manualDate,
        month: manualMonth,
        payment_mode: manualMode,
        upi_transaction_id: manualRef || null
      });
      setShowManualPayment(false); resetForms();
      await loadBuilding(selectedBuilding);
      showSuccess('Payment recorded. Receipt sent to tenant on WhatsApp.');
    } catch (err) {
      setFormError(parseApiError(err, 'Failed to record'));
    } finally { setFormLoading(false); }
  }

  async function handleSendReminder(tenant) {
    setActionLoading('remind-' + tenant.id);
    try {
      await sendReminder(tenant.id);
      showSuccess('Reminder sent to ' + tenant.name + ' on WhatsApp');
    } catch (err) {
      alert(parseApiError(err, 'Failed to send reminder'));
    } finally { setActionLoading(null); }
  }

  async function handleMoveOut() {
    setFormLoading(true); setFormError('');
    try {
      const res = await tenantMoveOut(selectedTenantForMoveOut.id, {
        deposit_refunded: moveOutDepositRefunded,
        refund_amount: moveOutRefundAmount ? parseFloat(moveOutRefundAmount) : null
      });
      setShowMoveOut(false); resetForms();
      await loadBuilding(selectedBuilding);
      showSuccess(
        selectedTenantForMoveOut.name + ' moved out. ' +
        (res.data.deposit_refunded
          ? 'Deposit Rs.' + res.data.refund_amount.toLocaleString() + ' marked refunded.'
          : 'Deposit Rs.' + res.data.deposit_amount.toLocaleString() + ' pending refund.')
      );
    } catch (err) {
      setFormError(parseApiError(err, 'Failed'));
    } finally { setFormLoading(false); }
  }

  async function handleViewHistory(tenant) {
    setSelectedTenantForHistory(tenant);
    try {
      const res = await getTenantPaymentHistory(tenant.id);
      setPaymentHistory(res.data);
      setShowHistory(true);
    } catch (err) {
      alert('Failed to load history');
    }
  }

  async function handleOpenKyc(tenant) {
    setSelectedTenantForKyc(tenant);
    setKycError('');
    setKycUrls(null);
    setShowKyc(true);
    // Load existing KYC URLs
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/tenants/${tenant.id}/kyc/urls`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('hashvi_token')}` }
      });
      if (res.ok) {
        const data = await res.json();
        setKycUrls(data);
      }
    } catch (err) {
      console.error('Failed to load KYC URLs');
    }
  }

  async function handleKycUpload(tenantId, file, type) {
    setKycUploading(true);
    setKycError('');
    const formData = new FormData();
    formData.append('file', file);
    try {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/tenants/${tenantId}/kyc/${type}`, {
        method: 'POST',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('hashvi_token')}` },
        body: formData
      });
      if (!res.ok) {
        const data = await res.json();
        throw new Error(data.detail || 'Upload failed');
      }
      await res.json(); // consume response
      // Reload KYC URLs immediately to reflect new state
      const urlRes = await fetch(`${process.env.REACT_APP_API_URL}/tenants/${tenantId}/kyc/urls`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('hashvi_token')}` }
      });
      if (urlRes.ok) {
        const urlData = await urlRes.json();
        setKycUrls(urlData);
      }
      // Also reload units to update the KYC button colour in tenant list
      if (selectedBuilding) await loadBuilding(selectedBuilding);
      showSuccess(`${type === 'id_doc' ? 'ID Document' : 'Photo'} uploaded successfully`);
    } catch (err) {
      setKycError(err.message || 'Upload failed');
    } finally { setKycUploading(false); }
  }

  async function handleDeleteKyc(tenantId, type = 'all') {
    const label = type === 'id_doc' ? 'ID Document' : type === 'photo' ? 'Tenant Photo' : 'all KYC documents';
    if (!window.confirm(`Delete ${label} for this tenant?`)) return;
    setKycUploading(true);
    try {
      const url = type === 'all'
        ? `${process.env.REACT_APP_API_URL}/tenants/${tenantId}/kyc`
        : `${process.env.REACT_APP_API_URL}/tenants/${tenantId}/kyc/${type}`;
      await fetch(url, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${localStorage.getItem('hashvi_token')}` }
      });
      // Reload KYC URLs
      const urlRes = await fetch(`${process.env.REACT_APP_API_URL}/tenants/${tenantId}/kyc/urls`, {
        headers: { 'Authorization': `Bearer ${localStorage.getItem('hashvi_token')}` }
      });
      if (urlRes.ok) setKycUrls(await urlRes.json());
      if (selectedBuilding) await loadBuilding(selectedBuilding);
      showSuccess(`${label} deleted`);
    } catch (err) {
      setKycError(`Failed to delete ${label}`);
    } finally { setKycUploading(false); }
  }

  async function handleOpenDepositModal(tenant) {
    setSelectedTenantForDeposit(tenant);
    setDepositError('');
    setDepositInstalment('');
    setDepositDate(new Date().toISOString().split('T')[0]);
    setDepositMode('Cash');
    setDepositRef('');
    setDepositNote('');
    try {
      const res = await getDepositPayments(tenant.id);
      setDepositHistory(res.data);
    } catch (err) {
      setDepositHistory(null);
    }
    setShowDepositModal(true);
  }

  async function handleRecordDeposit() {
    if (!depositInstalment || isNaN(depositInstalment) || parseFloat(depositInstalment) <= 0) {
      setDepositError('Enter a valid amount');
      return;
    }
    if (!depositDate) { setDepositError('Select a payment date'); return; }
    setDepositLoading(true); setDepositError('');
    try {
      const res = await recordDepositPayment(selectedTenantForDeposit.id, {
        amount_paid: parseFloat(depositInstalment),
        payment_date: depositDate,
        payment_mode: depositMode,
        reference: depositRef || null,
        note: depositNote || null
      });
      // Refresh deposit history in modal
      const updated = await getDepositPayments(selectedTenantForDeposit.id);
      setDepositHistory(updated.data);
      setDepositInstalment('');
      setDepositDate(new Date().toISOString().split('T')[0]);
      setDepositRef('');
      setDepositNote('');
      showSuccess(
        res.data.fully_paid
          ? selectedTenantForDeposit.name + ' — deposit fully collected!'
          : 'Deposit instalment recorded. Balance: ₹' + res.data.balance_remaining.toLocaleString()
      );
    } catch (err) {
      setDepositError(parseApiError(err, 'Failed to record'));
    } finally {
      setDepositLoading(false);
    }
  }

  async function handleDeleteDepositPayment(dpId) {
    if (!window.confirm('Remove this deposit instalment?')) return;
    try {
      await deleteDepositPayment(dpId);
      const updated = await getDepositPayments(selectedTenantForDeposit.id);
      setDepositHistory(updated.data);
      showSuccess('Deposit entry removed.');
    } catch (err) {
      alert(parseApiError(err, 'Failed to remove'));
    }
  }

  // ── Pro-rata helpers ────────────────────────────────────────
  function calcProrata(moveInDate, rentAmount) {
    const d = new Date(moveInDate);
    const year = d.getFullYear();
    const month = d.getMonth(); // 0-indexed
    const day = d.getDate();
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const daysRemaining = daysInMonth - day + 1;
    const amount = Math.round((rentAmount / daysInMonth) * daysRemaining);
    const monthNames = ['January','February','March','April','May','June',
                        'July','August','September','October','November','December'];
    const monthStr = monthNames[month] + '-' + year;
    return { days: daysRemaining, daysInMonth, amount, month: monthStr, year, monthNum: month };
  }

  function isMidMonthMoveIn(moveInDate) {
    if (!moveInDate) return false;
    const d = new Date(moveInDate);
    return d.getDate() > 1;
  }

  function handleOpenProrataModal(tenant, unit) {
    const pr = calcProrata(tenant.move_in_date, unit.rent_amount);
    setProrataData({ tenant, unit, ...pr });
    setManualAmount(String(pr.amount));
    setManualMonth(pr.month);
    setManualDate(tenant.move_in_date);
    setManualMode('Cash');
    setManualRef('');
    setSelectedTenantForPayment(tenant);
    setShowProrataModal(true);
    setFormError('');
  }

  async function handleSaveProrata() {
    if (!manualAmount || isNaN(manualAmount)) { setFormError('Enter valid amount'); return; }
    if (!manualDate) { setFormError('Select payment date'); return; }
    setFormLoading(true); setFormError('');
    try {
      await recordManualPayment({
        tenant_id: selectedTenantForPayment.id,
        amount: parseFloat(manualAmount),
        payment_date: manualDate,
        month: manualMonth,
        payment_mode: manualMode,
        upi_transaction_id: manualRef || null
      });
      setShowProrataModal(false);
      setProrataDismissed(prev => ({ ...prev, [selectedTenantForPayment.id]: true }));
      resetForms();
      await loadBuilding(selectedBuilding);
      showSuccess('Pro-rata rent recorded. Receipt sent to ' + prorataData.tenant.name + ' on WhatsApp.');
    } catch (err) {
      setFormError(parseApiError(err, 'Failed to record'));
    } finally { setFormLoading(false); }
  }

  async function handleApprove(paymentId) {
    setActionLoading(paymentId);
    try {
      await approvePayment(paymentId);
      await loadData();
    } catch (err) {
      alert(parseApiError(err, 'Error'));
    } finally { setActionLoading(null); }
  }

  async function handleReject(paymentId) {
    const reason = window.prompt(
      'Reason for rejection (required — tenant will be notified):\n\nExamples: "Screenshot is unclear", "Amount does not match", "Transaction ID not found"'
    );
    if (reason === null) return; // User cancelled
    if (!reason.trim()) {
      alert('Please provide a reason for rejection.');
      return;
    }
    setActionLoading(paymentId);
    try {
      await rejectPayment(paymentId, reason.trim());
      await loadData();
    } catch (err) {
      alert(parseApiError(err, 'Error'));
    } finally {
      setActionLoading(null);
    }
  }

  async function handleDownloadExcel() {
    setShowDownloadModal(true);
  }

  async function executeDownload() {
    try {
      let month, startMonth, endMonth;
      
      if (downloadType === 'month') {
        month = `${downloadYear}-${downloadMonth}`;
      } else if (downloadType === 'year') {
        startMonth = `${downloadYear}-01`;
        endMonth = `${downloadYear}-12`;
      } else {
        startMonth = downloadFromMonth;
        endMonth = downloadToMonth;
      }
      
      const response = await downloadRentReport(
        downloadType === 'month' ? month : null,
        selectedBuilding?.id,
        downloadType !== 'month' ? startMonth : null,
        downloadType !== 'month' ? endMonth : null
      );
      
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      
      let filename;
      if (downloadType === 'month') {
        filename = `Hashvi_Rent_Collection_${selectedBuilding?.name || 'All'}_${month}.xlsx`;
      } else if (downloadType === 'year') {
        filename = `Hashvi_Rent_Collection_${selectedBuilding?.name || 'All'}_${downloadYear}.xlsx`;
      } else {
        filename = `Hashvi_Rent_Collection_${selectedBuilding?.name || 'All'}_${startMonth}_to_${endMonth}.xlsx`;
      }
      
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
      
      setShowDownloadModal(false);
      showSuccess('Excel report downloaded successfully');
    } catch (err) {
      alert('Failed to download report: ' + (err.response?.data?.detail || err.message));
    }
  }

  async function handleRemindAllArrears() {
    if (!window.confirm(
      'Send arrears reminders to all tenants with outstanding dues?'
    )) return;
    setArrearsLoading(true);
    try {
      const res = await remindAllArrears(selectedBuilding.id);
      showSuccess(res.data.message);
      await loadBuilding(selectedBuilding);
    } catch (err) {
      alert('Failed to send reminders');
    } finally {
      setArrearsLoading(false); }
  }

  async function handleViewTenantArrears(tenant) {
    setSelectedTenantArrears(tenant);
    try {
      const res = await getTenantArrears(tenant.tenant_id || tenant.id);
      setTenantArrearsDetail(res.data);
      setShowTenantArrears(true);
    } catch (err) {
      alert('Failed to load arrears');
    }
  }

  function refLabel() {
    if (manualMode === 'UPI') return 'UPI Transaction ID';
    if (manualMode === 'Bank Transfer') return 'Bank Reference / UTR Number';
    if (manualMode === 'Cheque') return 'Cheque Number';
    return null;
  }

  function refPlaceholder() {
    if (manualMode === 'UPI') return 'e.g. 606711011862';
    if (manualMode === 'Bank Transfer') return 'e.g. UTR123456789012';
    if (manualMode === 'Cheque') return 'e.g. 000123';
    return '';
  }

  if (loading) {
    return (
      <div style={{
        minHeight: '100vh', display: 'flex',
        alignItems: 'center', justifyContent: 'center', color: '#64748b'
      }}>Loading...</div>
    );
  }

  return (
    <div className="db-root">
      <style>{DB_STYLES}</style>

      {/* ── SIDEBAR ── */}
      <aside className="db-sidebar">
        <div className="sb-logo-wrap">
          <img src="/Hashvi_logo_white_no_BG.svg" alt="Hashvi" className="sb-logo-img" />
          <div className="sb-logo-pill">Rental</div>
        </div>

        <div className="sb-section-label">Properties</div>
        {buildings.map(b => (
          <button key={b.id} className={"sb-item" + (selectedBuilding?.id === b.id ? " active" : "")} onClick={() => loadBuilding(b)}>
            <span className="sb-dot"></span>{b.name}
          </button>
        ))}
        <button className="sb-item" onClick={() => { resetForms(); setShowAddBuilding(true); }} style={{ color: 'rgba(255,255,255,0.40)', fontSize: 12 }}>
          <span className="sb-dot"></span>+ Add Building
        </button>

        <div className="sb-section-label">Dashboard</div>
        {['overview','pending','manage','arrears','agreements','my-agreements'].map(tab => (
          <button key={tab} className={"sb-item" + (activeTab === tab ? " active" : "")} onClick={() => setActiveTab(tab)}>
            <span className="sb-dot"></span>
            {tab === 'pending' ? 'Pending Approvals' : tab === 'arrears' ? 'Arrears' : tab === 'agreements' ? 'Agreement Generator' : tab === 'my-agreements' ? 'My Agreements' : tab.charAt(0).toUpperCase() + tab.slice(1)}
            {tab === 'pending' && pending.length > 0 && <span className="sb-badge red">{pending.length}</span>}
            {tab === 'arrears' && arrearsData && arrearsData.tenants_with_arrears > 0 && <span className="sb-badge amber">{arrearsData.tenants_with_arrears}</span>}
          </button>
        ))}

        <div className="sb-bottom">
          <div className="sb-user">
            <div className="sb-avatar">{user.name ? user.name.charAt(0).toUpperCase() : 'L'}</div>
            <div>
              <div className="sb-user-name">{user.name}</div>
              <div className="sb-user-role">Landlord</div>
            </div>
            <button className="sb-logout-btn" onClick={onLogout}>Logout</button>
          </div>
        </div>
      </aside>

      {/* ── MAIN ── */}
      <div className="db-main">

        {/* ── MOBILE TOP NAV ── */}
        <div className="mob-nav">
          <img src="/Hashvi_logo_white_no_BG.svg" alt="Hashvi" className="mob-nav-logo" />
          <div className="mob-nav-right">
            <button className="mob-logout-btn" onClick={onLogout}>Logout</button>
            <button className="mob-hamburger" onClick={() => setMobDrawerOpen(true)}>&#9776;</button>
          </div>
        </div>

        {/* ── MOBILE HORIZONTAL TABS ── */}
        <div className="mob-tab-bar">
          <div className="mob-tab-bar-inner">
            {['overview','pending','manage','arrears','agreements','my-agreements'].map(tab => (
              <button key={tab}
                className={"mob-tab-btn" + (activeTab === tab ? " active" : "")}
                onClick={() => setActiveTab(tab)}>
                {tab === 'pending' ? 'Pending' : tab === 'arrears' ? 'Arrears' : tab === 'manage' ? 'Manage' : tab === 'agreements' ? 'Agreements' : tab === 'my-agreements' ? 'My Agreements' : 'Overview'}
                {tab === 'pending' && pending.length > 0 && <span className="mob-tab-badge red">{pending.length}</span>}
                {tab === 'arrears' && arrearsData && arrearsData.tenants_with_arrears > 0 && <span className="mob-tab-badge amber">{arrearsData.tenants_with_arrears}</span>}
              </button>
            ))}
          </div>
        </div>

        {/* ── MOBILE DRAWER OVERLAY ── */}
        <div className={"mob-overlay" + (mobDrawerOpen ? " open" : "")} onClick={() => setMobDrawerOpen(false)} />

        {/* ── MOBILE DRAWER ── */}
        <div className={"mob-drawer" + (mobDrawerOpen ? " open" : "")}>
          <div className="mob-drawer-head">
            <img src="/Hashvi_logo_white_no_BG.svg" alt="Hashvi" className="mob-drawer-logo" />
            <button className="mob-drawer-close" onClick={() => setMobDrawerOpen(false)}>&#x2715;</button>
          </div>
          <div className="sb-section-label">Properties</div>
          {buildings.map(b => (
            <button key={b.id}
              className={"sb-item" + (selectedBuilding?.id === b.id ? " active" : "")}
              onClick={() => { loadBuilding(b); setMobDrawerOpen(false); }}>
              <span className="sb-dot"></span>{b.name}
            </button>
          ))}
          <button className="sb-item"
            onClick={() => { resetForms(); setShowAddBuilding(true); setMobDrawerOpen(false); }}
            style={{ color: 'rgba(255,255,255,0.40)', fontSize: 12 }}>
            <span className="sb-dot"></span>+ Add Building
          </button>
          <div className="sb-section-label">Dashboard</div>
          {['overview','pending','manage','arrears','agreements','my-agreements'].map(tab => (
            <button key={tab}
              className={"sb-item" + (activeTab === tab ? " active" : "")}
              onClick={() => { setActiveTab(tab); setMobDrawerOpen(false); }}>
              <span className="sb-dot"></span>
              {tab === 'pending' ? 'Pending Approvals' : tab === 'arrears' ? 'Arrears' : tab === 'agreements' ? 'Agreement Generator' : tab === 'my-agreements' ? 'My Agreements' : tab.charAt(0).toUpperCase() + tab.slice(1)}
              {tab === 'pending' && pending.length > 0 && <span className="sb-badge red">{pending.length}</span>}
              {tab === 'arrears' && arrearsData && arrearsData.tenants_with_arrears > 0 && <span className="sb-badge amber">{arrearsData.tenants_with_arrears}</span>}
            </button>
          ))}
          <div className="sb-bottom">
            <div className="sb-user">
              <div className="sb-avatar">{user.name ? user.name.charAt(0).toUpperCase() : 'L'}</div>
              <div>
                <div className="sb-user-name">{user.name}</div>
                <div className="sb-user-role">Landlord</div>
              </div>
            </div>
            <button className="sb-logout-btn"
              style={{ marginTop: 12, width: '100%', textAlign: 'center' }}
              onClick={onLogout}>Logout</button>
          </div>
        </div>

        {/* TOAST */}
        {successMsg && <div className="toast">&#x2713; {successMsg}</div>}

        {/* TOPBAR */}
        <div className="db-topbar">
          <div>
            <div className="topbar-title">
              {activeTab === 'overview' ? 'Overview' : activeTab === 'pending' ? 'Pending Approvals' : activeTab === 'manage' ? 'Manage Units' : activeTab === 'agreements' ? 'Agreement Generator' : activeTab === 'my-agreements' ? 'My Agreements' : 'Arrears'}
            </div>
            <div className="topbar-sub">{rentStatus?.month} · {selectedBuilding?.name}</div>
          </div>
          <div className="topbar-right">
            {referralCode && (
              <div className="referral-chip">
                Referral: <span className="referral-code">{referralCode}</span>
              </div>
            )}
            {referralCode && (
              <button className="btn-topbar" onClick={handleCopyReferral}>
                {referralCopied ? '✓ Copied!' : 'Copy Link'}
              </button>
            )}
            {activeTab === 'overview' && selectedBuilding && (
              <button className="btn-topbar orange" onClick={handleDownloadExcel}>
                ↓ Download Report
              </button>
            )}
            {activeTab === 'manage' && selectedBuilding && (
              <button className="btn-topbar orange" onClick={() => { resetForms(); setShowAddUnit(true); }}>+ Add Unit</button>
            )}
          </div>
        </div>

        {/* CONTENT */}
        <div className="db-content">

        {/* OVERVIEW TAB */}
        {activeTab === 'overview' && rentStatus && (
          <div>
            <div className="stat-grid">
              <div className="stat-card navy">
                <div className="stat-lbl">Total Units</div>
                <div className="stat-val">{rentStatus.total_units}</div>
                <div className="stat-sub">{selectedBuilding?.name}</div>
              </div>
              <div className="stat-card green">
                <div className="stat-lbl">{'Paid — ' + rentStatus.month}</div>
                <div className="stat-val green">{rentStatus.paid_count}</div>
                <div className="stat-sub">{'₹' + (rentStatus.paid || []).reduce((a, t) => a + t.rent_amount, 0).toLocaleString() + ' collected'}</div>
              </div>
              <div className="stat-card red">
                <div className="stat-lbl">{'Unpaid — ' + rentStatus.month}</div>
                <div className="stat-val red">{rentStatus.unpaid_count}</div>
                <div className="stat-sub">{'₹' + (rentStatus.unpaid || []).reduce((a, t) => a + t.rent_amount, 0).toLocaleString() + ' pending'}</div>
              </div>
              <div className="stat-card orange">
                <div className="stat-lbl">Pending Approvals</div>
                <div className={'stat-val' + (pending.length > 0 ? ' orange' : '')}>{pending.length}</div>
                <div className="stat-sub">{pending.length > 0 ? 'Awaiting review' : 'All clear'}</div>
              </div>
            </div>

            <div className="tbl-wrap">
              <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '14px 18px', borderBottom: '1px solid #f1f5f9' }}>
                <p style={{ fontSize: 14, fontWeight: 700, color: '#0f172a', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                  {selectedBuilding?.name} — {rentStatus.month}
                </p>
                {rentStatus.is_grace_period && rentStatus.upcoming_month && (
                  <span style={{ background: '#dbeafe', color: '#1e40af', fontSize: 12, fontWeight: 500, padding: '4px 12px', borderRadius: 20, border: '1px solid #bfdbfe' }}>
                    {rentStatus.upcoming_month} collection upcoming
                  </span>
                )}
              </div>
              <div className="tbl-head">
                <span>Tenant</span><span>Rent</span><span>Month</span><span>Status</span><span>Actions</span>
              </div>
                  {rentStatus.paid.map(function(t) {
                    return (
                      <div key={t.tenant_id} className="tbl-row">
                        <div><div className="t-name">{t.tenant_name}</div><div className="t-unit">{'Unit ' + t.unit_number + ' · ' + (t.unit_type === 'lease' ? 'Maintenance' : 'Rent')}</div></div>
                        <div className="t-cell">{'₹' + t.rent_amount.toLocaleString()}</div>
                        <div className="t-cell muted">{rentStatus.month}</div>
                        <div><span className="status-pill paid">PAID</span></div>
                        <div className="act-row">
                          <a href={process.env.REACT_APP_API_URL + '/receipt/' + t.payment_id} target="_blank" rel="noreferrer" className="act-btn">Receipt</a>
                        </div>
                      </div>
                    );
                  })}

              {rentStatus.unpaid.length > 0 && rentStatus.unpaid.map(function(t) {
                    return (
                      <div key={t.tenant_id} className="tbl-row">
                        <div><div className="t-name">{t.tenant_name}</div><div className="t-unit">{'Unit ' + t.unit_number + ' · ' + (t.unit_type === 'lease' ? 'Maintenance' : 'Rent')}</div></div>
                        <div className="t-cell">{'₹' + t.rent_amount.toLocaleString()}</div>
                        <div className="t-cell muted">{rentStatus.month}</div>
                        <div><span className="status-pill unpaid">UNPAID</span></div>
                        <div className="act-row">
                          <button className="act-btn remind" onClick={() => handleSendReminder({ id: t.tenant_id, name: t.tenant_name })} disabled={actionLoading === 'remind-' + t.tenant_id}>
                            {actionLoading === 'remind-' + t.tenant_id ? '...' : 'Remind'}
                          </button>
                          <button className="act-btn record" onClick={() => { setSelectedTenantForPayment({ id: t.tenant_id, name: t.tenant_name }); setManualMonth(rentStatus.month); setManualAmount(String(t.rent_amount)); setManualDate(new Date().toISOString().split('T')[0]); setFormError(''); setShowManualPayment(true); }}>
                            Record
                          </button>
                        </div>
                      </div>
                    );
                  })}

              {rentStatus.is_grace_period && rentStatus.upcoming && rentStatus.upcoming.map(function(t) {
                    return (
                      <div key={'up-' + t.tenant_id} className="tbl-row">
                        <div><div className="t-name">{t.tenant_name}</div><div className="t-unit">{'Unit ' + t.unit_number + ' · due by 10th'}</div></div>
                        <div className="t-cell">{'₹' + t.rent_amount.toLocaleString()}</div>
                        <div className="t-cell muted">{rentStatus.upcoming_month}</div>
                        <div><span className="status-pill upcoming">UPCOMING</span></div>
                        <div className="act-row">
                          <button className="act-btn record" onClick={() => { setSelectedTenantForPayment({ id: t.tenant_id, name: t.tenant_name }); setManualMonth(rentStatus.upcoming_month); setManualAmount(String(t.rent_amount)); setManualDate(new Date().toISOString().split('T')[0]); setFormError(''); setShowManualPayment(true); }}>
                            Record
                          </button>
                        </div>
                      </div>
                    );
                  })}
            </div>
          </div>
        )}

        {activeTab === 'overview' && !rentStatus && (
          <div style={{
            background: 'white', borderRadius: 12,
            border: '1px solid #e2e8f0', padding: 40, textAlign: 'center'
          }}>
            <p style={{ color: '#64748b' }}>No buildings found.</p>
            <button onClick={() => { resetForms(); setShowAddBuilding(true); }} style={{
              marginTop: 12, background: '#1f4e79', color: 'white',
              padding: '8px 20px', borderRadius: 8, border: 'none',
              fontSize: 14, cursor: 'pointer'
            }}>Add Your First Building</button>
          </div>
        )}

        {/* PENDING TAB */}
        {activeTab === 'pending' && (
          <div>
            <p style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>
              Payments Awaiting Approval
            </p>
            {pending.length === 0 ? (
              <div style={{
                background: 'white', borderRadius: 12,
                border: '1px solid #e2e8f0', padding: 40, textAlign: 'center'
              }}>
                <p style={{ color: '#64748b' }}>No pending payments</p>
                <p style={{ color: '#94a3b8', fontSize: 12, marginTop: 4 }}>All payments confirmed</p>
              </div>
            ) : (
              pending.map(function(p) {
                return (
                  <div key={p.payment_id} style={{
                    background: 'white', borderRadius: 12,
                    border: '1px solid #e2e8f0', padding: 20, marginBottom: 12
                  }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                      <div>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                          <p style={{ fontWeight: 600, fontSize: 15 }}>{p.tenant_name}</p>
                          {!p.amount_matches && (
                            <span style={{
                              background: '#fef3c7', color: '#92400e',
                              padding: '2px 8px', borderRadius: 4, fontSize: 11
                            }}>Amount mismatch</span>
                          )}
                        </div>
                        <p style={{ color: '#64748b', fontSize: 13, marginBottom: 2 }}>
                          {'₹' + (p.amount ? p.amount.toLocaleString() : '0') + ' · ' + p.month}
                        </p>
                        <p style={{ color: '#94a3b8', fontSize: 12, marginBottom: 2 }}>
                          {'UPI: ' + (p.upi_transaction_id || 'Not captured')}
                        </p>
                        <p style={{ color: '#94a3b8', fontSize: 12 }}>
                          {'Auto-approves: ' + new Date(p.approval_deadline).toLocaleString()}
                        </p>
                      </div>
                      <div style={{ display: 'flex', gap: 8 }}>
                        <button onClick={() => handleApprove(p.payment_id)}
                          disabled={actionLoading === p.payment_id} style={{
                            background: '#dcfce7', color: '#166534',
                            padding: '8px 18px', borderRadius: 6,
                            fontSize: 13, fontWeight: 500, border: 'none', cursor: 'pointer'
                          }}>
                          {actionLoading === p.payment_id ? '...' : 'Approve'}
                        </button>
                        <button onClick={() => handleReject(p.payment_id)}
                          disabled={actionLoading === p.payment_id} style={{
                            background: '#fee2e2', color: '#991b1b',
                            padding: '8px 18px', borderRadius: 6,
                            fontSize: 13, fontWeight: 500, border: 'none', cursor: 'pointer'
                          }}>Reject</button>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        )}

        {/* MANAGE TAB */}
        {activeTab === 'manage' && selectedBuilding && (
          <div>
            {/* ── BUILDING SETTINGS ── */}
            <div style={{
              background: 'white', borderRadius: 14,
              border: '1px solid rgba(31,78,121,0.10)',
              padding: '20px 24px', marginBottom: 20,
              boxShadow: '0 2px 8px rgba(31,78,121,0.04)'
            }}>
              <p style={{
                fontFamily: 'Plus Jakarta Sans, sans-serif',
                fontSize: 14, fontWeight: 700, color: '#0f172a', marginBottom: 16
              }}>
                🏠 {selectedBuilding.name} — Settings
              </p>
              <div style={{ display: 'flex', alignItems: 'flex-end', gap: 12, flexWrap: 'wrap' }}>
                <div style={{ flex: 1, minWidth: 200 }}>
                  <label style={{ display: 'block', fontSize: 12, fontWeight: 600, color: '#374151', marginBottom: 6 }}>
                    UPI ID for Payment Links
                  </label>
                  <input
                    type="text"
                    placeholder="e.g. 9741400302@upi or name@okicici"
                    value={editBuildingUpiId}
                    onChange={e => setEditBuildingUpiId(e.target.value)}
                    style={{ ...inputStyle, marginBottom: 0 }}
                  />
                  <p style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>
                    Tenants receive a tap-to-pay link in WhatsApp reminders — opens GPay/PhonePe pre-filled.
                  </p>
                </div>
                <button
                  onClick={handleSaveUpiId}
                  disabled={savingUpiId}
                  style={{
                    background: '#1f4e79', color: 'white',
                    padding: '10px 20px', borderRadius: 8,
                    fontSize: 13, fontWeight: 600,
                    border: 'none', cursor: 'pointer',
                    flexShrink: 0, whiteSpace: 'nowrap'
                  }}>
                  {savingUpiId ? 'Saving...' : '💾 Save UPI ID'}
                </button>
              </div>
              {selectedBuilding.upi_id && (
                <div style={{
                  marginTop: 10, background: '#f0fdf4',
                  border: '1px solid #bbf7d0', borderRadius: 8,
                  padding: '8px 14px', fontSize: 12, color: '#166534'
                }}>
                  ✅ Active UPI ID: <strong>{selectedBuilding.upi_id}</strong> — Payment links enabled
                </div>
              )}
            </div>

            <div style={{
              display: 'flex', justifyContent: 'space-between',
              alignItems: 'center', marginBottom: 16
            }}>
              <p style={{ fontSize: 16, fontWeight: 600 }}>
                {selectedBuilding.name} — Units and Tenants
              </p>
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={() => {
                  setEditBuildingName(selectedBuilding.name);
                  setEditBuildingAddress(selectedBuilding.address);
                  setFormError(''); setFormLoading(false);
                  setShowEditBuilding(true);
                }} style={{
                  background: '#f8fafc', color: '#1f4e79',
                  padding: '8px 14px', borderRadius: 8,
                  fontSize: 13, fontWeight: 500,
                  border: '1.5px solid #e2e8f0', cursor: 'pointer'
                }}>✏️ Edit Building</button>
                <button onClick={() => { resetForms(); setShowAddUnit(true); }} style={{
                  background: '#1f4e79', color: 'white',
                  padding: '8px 16px', borderRadius: 8,
                  fontSize: 13, fontWeight: 500, border: 'none', cursor: 'pointer'
                }}>+ Add Unit</button>
                <button onClick={() => {
                  setFormError(''); setFormLoading(false);
                  setShowDeleteBuilding(true);
                }} style={{
                  background: '#fef2f2', color: '#dc2626',
                  padding: '8px 14px', borderRadius: 8,
                  fontSize: 13, fontWeight: 500,
                  border: '1.5px solid #fecaca', cursor: 'pointer'
                }}>🗑️ Delete</button>
              </div>
            </div>

            {units.length === 0 ? (
              <div style={{
                background: 'white', borderRadius: 12,
                border: '1px solid #e2e8f0', padding: 40, textAlign: 'center'
              }}>
                <p style={{ color: '#64748b' }}>No units yet</p>
                <button onClick={() => { resetForms(); setShowAddUnit(true); }} style={{
                  marginTop: 12, background: '#1f4e79', color: 'white',
                  padding: '8px 20px', borderRadius: 8, border: 'none',
                  fontSize: 14, cursor: 'pointer'
                }}>Add First Unit</button>
              </div>
            ) : (
              units.map(function(unit) {
                const activeTenantsOnly = (unit.tenants || []).filter(t => t.is_active !== false);
                return (
                  <div key={unit.id} style={{
                    background: 'white', borderRadius: 12,
                    border: '1px solid #e2e8f0', padding: 20, marginBottom: 12
                  }}>
                    <div style={{
                      display: 'flex', justifyContent: 'space-between',
                      alignItems: 'center', marginBottom: 12
                    }}>
                      <div>
                        <p style={{ fontWeight: 600, fontSize: 15 }}>
                          {'Unit ' + unit.unit_number}
                          {unit.floor && (
                            <span style={{ color: '#94a3b8', fontWeight: 400, fontSize: 13, marginLeft: 8 }}>
                              {'Floor ' + unit.floor}
                            </span>
                          )}
                          {unit.unit_type === 'lease' && (
                            <span style={{
                              marginLeft: 8, background: '#ede9fe',
                              color: '#6d28d9', fontSize: 11,
                              fontWeight: 600, padding: '2px 8px',
                              borderRadius: 20
                            }}>LEASE</span>
                          )}
                        </p>
                        <p style={{ color: '#64748b', fontSize: 13, marginTop: 2 }}>
                          {(unit.unit_type === 'lease' ? 'Maintenance: ₹' : 'Rent: ₹') + unit.rent_amount.toLocaleString() + '/month'}
                          {unit.unit_type === 'lease' && unit.lease_amount && (
                            <span style={{ marginLeft: 8, color: '#94a3b8' }}>
                              · Lease: ₹{unit.lease_amount.toLocaleString()}
                            </span>
                          )}
                        </p>
                      </div>
                      <div style={{ display: 'flex', gap: 8 }}>
                        <button onClick={() => {
                          setSelectedUnitForEdit(unit);
                          setUnitNumber(unit.unit_number);
                          setUnitFloor(unit.floor ? String(unit.floor) : '');
                          setUnitRent(String(unit.rent_amount));
                          setUnitType(unit.unit_type || 'rental');
                          setLeaseAmount(unit.lease_amount ? String(unit.lease_amount) : '');
                          setFormError('');
                          setShowEditUnit(true);
                        }} style={{
                          background: '#f1f5f9', color: '#374151',
                          padding: '7px 14px', borderRadius: 7,
                          fontSize: 13, border: '1px solid #e2e8f0', cursor: 'pointer'
                        }}>Edit</button>
                        <button onClick={() => {
                          resetForms();
                          setSelectedUnitForTenant(unit);
                          setShowAddTenant(true);
                        }} style={{
                          background: '#f0fdf4', color: '#166534',
                          padding: '7px 14px', borderRadius: 7,
                          fontSize: 13, fontWeight: 500,
                          border: '1px solid #bbf7d0', cursor: 'pointer'
                        }}>+ Add Tenant</button>
                        <button onClick={() => {
                          setSelectedUnitForDelete(unit);
                          setFormError('');
                          setShowDeleteUnit(true);
                        }} style={{
                          background: '#fee2e2', color: '#991b1b',
                          padding: '7px 14px', borderRadius: 7,
                          fontSize: 13, border: '1px solid #fca5a5', cursor: 'pointer'
                        }}>Delete</button>
                      </div>
                    </div>

                    {activeTenantsOnly.length > 0 ? (
                      activeTenantsOnly.map(function(t) {
                        return (
                          <div key={t.id} style={{
                            background: '#f8fafc', borderRadius: 8,
                            padding: '12px 14px', marginTop: 8,
                            border: '1px solid #f1f5f9'
                          }}>
                            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
                              <div>
                                <p style={{ fontWeight: 500, fontSize: 14 }}>{t.name}</p>
                                <p style={{ color: '#94a3b8', fontSize: 12, marginTop: 2 }}>
                                  {t.phone}
                                  {t.email ? ' · ' + t.email : ''}
                                  {t.aadhaar_last4 ? ' · Aadhaar ****' + t.aadhaar_last4 : ''}
                                  {t.deposit_amount ? ' · Deposit ₹' + t.deposit_amount.toLocaleString() : ''}
                                  {t.move_in_date ? ' · Since ' + t.move_in_date : ''}
                                </p>
                              </div>
                              <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                                <button
                                  onClick={() => handleViewHistory(t)}
                                  style={{
                                    background: '#eff6ff', color: '#1e40af',
                                    padding: '5px 10px', borderRadius: 6,
                                    fontSize: 12, border: '1px solid #bfdbfe', cursor: 'pointer'
                                  }}>History</button>
                                <button
                                  onClick={() => handleOpenKyc(t)}
                                  style={{
                                    background: (t.kyc_id_doc_url && t.kyc_photo_url) ? '#f0fdf4'
                                      : (t.kyc_id_doc_url || t.kyc_photo_url) ? '#fffbeb' : '#fafafa',
                                    color: (t.kyc_id_doc_url && t.kyc_photo_url) ? '#166534'
                                      : (t.kyc_id_doc_url || t.kyc_photo_url) ? '#92400e' : '#64748b',
                                    padding: '5px 10px', borderRadius: 6, fontSize: 12,
                                    border: (t.kyc_id_doc_url && t.kyc_photo_url) ? '1px solid #bbf7d0'
                                      : (t.kyc_id_doc_url || t.kyc_photo_url) ? '1px solid #fde68a' : '1px solid #e2e8f0',
                                    cursor: 'pointer'
                                  }}>
                                  {(t.kyc_id_doc_url && t.kyc_photo_url) ? '✓ KYC'
                                    : (t.kyc_id_doc_url || t.kyc_photo_url) ? '⚠ KYC' : 'KYC'}
                                </button>
                                {t.deposit_amount > 0 && (
                                  <button
                                    onClick={() => handleOpenDepositModal(t)}
                                    style={{
                                      background: '#fdf4ff', color: '#7e22ce',
                                      padding: '5px 10px', borderRadius: 6,
                                      fontSize: 12, border: '1px solid #e9d5ff', cursor: 'pointer'
                                    }}>Deposit</button>
                                )}
                                <button
                                  onClick={() => {
                                    setSelectedTenantForEdit({ ...t, unit_id: unit.id });
                                    setTenantName(t.name);
                                    setTenantPhone(t.phone);
                                    setTenantEmail(t.email || '');
                                    setTenantAadhaar(t.aadhaar_last4 || '');
                                    setTenantDeposit(t.deposit_amount ? String(t.deposit_amount) : '');
                                    setTenantMoveIn(t.move_in_date || '');
                                    setFormError('');
                                    setShowEditTenant(true);
                                  }}
                                  style={{
                                    background: '#f0fdf4', color: '#166534',
                                    padding: '5px 10px', borderRadius: 6,
                                    fontSize: 12, border: '1px solid #bbf7d0', cursor: 'pointer'
                                  }}>Edit</button>
                                <button
                                  onClick={() => {
                                    setSelectedTenantForMoveOut(t);
                                    setMoveOutRefundAmount(t.deposit_amount ? String(t.deposit_amount) : '');
                                    setMoveOutDepositRefunded(false);
                                    setFormError('');
                                    setShowMoveOut(true);
                                  }}
                                  style={{
                                    background: '#fff7ed', color: '#c2410c',
                                    padding: '5px 10px', borderRadius: 6,
                                    fontSize: 12, border: '1px solid #fed7aa', cursor: 'pointer'
                                  }}>Move Out</button>
                                <button
                                  onClick={() => {
                                    setSelectedTenantForDelete(t);
                                    setFormError('');
                                    setShowDeleteTenant(true);
                                  }}
                                  style={{
                                    background: '#fee2e2', color: '#991b1b',
                                    padding: '5px 10px', borderRadius: 6,
                                    fontSize: 12, border: '1px solid #fca5a5', cursor: 'pointer'
                                  }}>Delete</button>
                                <span style={{
                                  background: '#dbeafe', color: '#1e40af',
                                  padding: '3px 10px', borderRadius: 20,
                                  fontSize: 12, fontWeight: 500
                                }}>Active</span>
                              </div>
                            </div>

                            {/* Pro-rata nudge banner */}
                            {isMidMonthMoveIn(t.move_in_date) && !prorataDismissed[t.id] && (() => {
                              const pr = calcProrata(t.move_in_date, unit.rent_amount);
                              // Only show if move-in is current month and no payment recorded yet
                              const now = new Date();
                              const moveIn = new Date(t.move_in_date);
                              const isSameMonth = moveIn.getMonth() === now.getMonth() && moveIn.getFullYear() === now.getFullYear();
                              if (!isSameMonth) return null;
                              return (
                                <div style={{
                                  marginTop: 10,
                                  background: '#fffbeb', borderRadius: 8,
                                  border: '1px solid #fde68a', padding: '12px 14px'
                                }}>
                                  <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', flexWrap: 'wrap', gap: 10 }}>
                                    <div>
                                      <p style={{ fontSize: 13, fontWeight: 600, color: '#92400e', margin: '0 0 3px' }}>
                                        Mid-month move-in · {t.move_in_date}
                                      </p>
                                      <p style={{ fontSize: 12, color: '#92400e', margin: 0, opacity: 0.85 }}>
                                        {pr.days} days remaining in month · Pro-rata = <strong>₹{pr.amount.toLocaleString()}</strong>
                                        &nbsp;<span style={{ opacity: 0.65 }}>(₹{unit.rent_amount.toLocaleString()} ÷ {pr.daysInMonth} × {pr.days})</span>
                                      </p>
                                    </div>
                                    <div style={{ display: 'flex', gap: 8, flexShrink: 0 }}>
                                      <button
                                        onClick={() => setProrataDismissed(prev => ({ ...prev, [t.id]: true }))}
                                        style={{
                                          background: 'white', color: '#92400e',
                                          border: '1px solid #fde68a', borderRadius: 6,
                                          padding: '5px 10px', fontSize: 12, cursor: 'pointer'
                                        }}>
                                        Skip → start {(() => { const d = new Date(t.move_in_date); return new Date(d.getFullYear(), d.getMonth()+1, 1).toLocaleString('default', { month: 'short' }); })()}
                                      </button>
                                      <button
                                        onClick={() => handleOpenProrataModal(t, unit)}
                                        style={{
                                          background: '#f59e0b', color: 'white',
                                          border: 'none', borderRadius: 6,
                                          padding: '5px 12px', fontSize: 12,
                                          fontWeight: 600, cursor: 'pointer'
                                        }}>
                                        Record ₹{pr.amount.toLocaleString()}
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              );
                            })()}
                          </div>
                        );
                      })
                    ) : (
                      <p style={{ color: '#94a3b8', fontSize: 13, fontStyle: 'italic', marginTop: 4 }}>
                        No tenant — unit is vacant
                      </p>
                    )}
                  </div>
                );
              })
            )}

            {/* Recently moved out tenants — shown for 90 days */}
            {recentMoveouts.length > 0 && (
              <div style={{ marginTop: 24 }}>
                <p style={{
                  fontSize: 13, fontWeight: 600, color: '#92400e',
                  marginBottom: 12, display: 'flex', alignItems: 'center', gap: 8
                }}>
                  Recently Moved Out
                  <span style={{
                    background: '#fef3c7', color: '#92400e',
                    padding: '2px 8px', borderRadius: 20,
                    fontSize: 11, fontWeight: 500
                  }}>Retained for 90 days</span>
                </p>
                {recentMoveouts.map(function(t) {
                  return (
                    <div key={t.id} style={{
                      background: 'white', borderRadius: 10,
                      border: '1px solid #fde68a',
                      borderLeft: '3px solid #f59e0b',
                      padding: '12px 16px', marginBottom: 8,
                      opacity: 0.85
                    }}>
                      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 8 }}>
                        <div>
                          <p style={{ fontWeight: 500, fontSize: 14 }}>{t.name}</p>
                          <p style={{ color: '#94a3b8', fontSize: 12, marginTop: 2 }}>
                            {t.phone}
                            {t.move_out_date ? ' · Moved out ' + t.move_out_date : ''}
                            {t.deposit_amount ? ' · Deposit ₹' + t.deposit_amount.toLocaleString() : ''}
                          </p>
                          <p style={{ color: '#d97706', fontSize: 11, marginTop: 3 }}>
                            {'Auto-removes in ' + t.days_until_archived + ' day(s)'}
                          </p>
                        </div>
                        <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                          <button
                            onClick={() => handleViewHistory(t)}
                            style={{
                              background: '#eff6ff', color: '#1e40af',
                              padding: '5px 10px', borderRadius: 6,
                              fontSize: 12, border: '1px solid #bfdbfe', cursor: 'pointer'
                            }}>History</button>
                          <span style={{
                            background: '#fef3c7', color: '#92400e',
                            padding: '3px 10px', borderRadius: 20,
                            fontSize: 11, fontWeight: 500
                          }}>Moved Out</span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        )}

        {/* ARREARS TAB */}
        {activeTab === 'arrears' && (
          <div>
            <div style={{
              display: 'flex', justifyContent: 'space-between',
              alignItems: 'center', marginBottom: 16
            }}>
              <p style={{ fontSize: 16, fontWeight: 600 }}>
                Outstanding Dues — {selectedBuilding?.name}
              </p>
              {arrearsData && arrearsData.tenants_with_arrears > 0 && (
                <button
                  onClick={handleRemindAllArrears}
                  disabled={arrearsLoading}
                  style={{
                    background: '#f59e0b', color: 'white',
                    padding: '8px 16px', borderRadius: 8,
                    fontSize: 13, fontWeight: 500,
                    border: 'none', cursor: 'pointer'
                  }}>
                  {arrearsLoading ? 'Sending...' : 'Send All Reminders'}
                </button>
              )}
            </div>

            {arrearsData && arrearsData.total_outstanding > 0 && (
              <div style={{
                background: '#fef3c7', borderRadius: 14,
                border: '1px solid #fde68a',
                padding: '16px 20px', marginBottom: 20,
                display: 'flex', justifyContent: 'space-between',
                alignItems: 'center'
              }}>
                <div>
                  <p style={{ fontSize: 13, color: '#92400e', marginBottom: 4 }}>
                    Total Outstanding
                  </p>
                  <p style={{ fontSize: 24, fontWeight: 700, color: '#92400e' }}>
                    {'₹' + arrearsData.total_outstanding.toLocaleString()}
                  </p>
                </div>
                <div style={{ textAlign: 'right' }}>
                  <p style={{ fontSize: 13, color: '#92400e', marginBottom: 4 }}>
                    Tenants with dues
                  </p>
                  <p style={{ fontSize: 24, fontWeight: 700, color: '#92400e' }}>
                    {arrearsData.tenants_with_arrears}
                  </p>
                </div>
              </div>
            )}

            {!arrearsData || arrearsData.tenants_with_arrears === 0 ? (
              <div style={{
                background: 'white', borderRadius: 12,
                border: '1px solid #e2e8f0',
                padding: 40, textAlign: 'center'
              }}>
                <p style={{ fontSize: 20 }}>✓</p>
                <p style={{ color: '#16a34a', fontWeight: 600, marginTop: 8 }}>
                  All tenants are up to date
                </p>
                <p style={{ color: '#94a3b8', fontSize: 12, marginTop: 4 }}>
                  No outstanding dues in the last 6 months
                </p>
              </div>
            ) : (
              arrearsData.arrears.map(function(t) {
                return (
                  <div key={t.tenant_id} style={{
                    background: 'white', borderRadius: 12,
                    border: '1px solid #e2e8f0',
                    padding: 20, marginBottom: 12
                  }}>
                    <div style={{
                      display: 'flex', justifyContent: 'space-between',
                      alignItems: 'flex-start'
                    }}>
                      <div>
                        <p style={{ fontWeight: 600, fontSize: 15, marginBottom: 4 }}>
                          {t.tenant_name}
                        </p>
                        <p style={{ color: '#64748b', fontSize: 13, marginBottom: 8 }}>
                          {'Unit ' + t.unit_number + ' · ₹' + t.rent_amount.toLocaleString() + (t.unit_type === 'lease' ? '/month maintenance' : '/month')}
                        </p>
                        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
                          {t.arrear_months.map(function(m) {
                            const isUpcoming = m.status === 'upcoming';
                            const isOverdue = !isUpcoming && m.days_overdue > 30;
                            return (
                              <span key={m.month} style={{
                                background: isUpcoming ? '#dbeafe' : isOverdue ? '#fee2e2' : '#fef9c3',
                                color: isUpcoming ? '#1e40af' : isOverdue ? '#991b1b' : '#854d0e',
                                padding: '3px 10px', borderRadius: 20,
                                fontSize: 11, fontWeight: 500
                              }}>
                                {m.month}
                                {isUpcoming ? ' — upcoming' : isOverdue ? ' — ' + m.days_overdue + 'd overdue' : ' — due'}
                              </span>
                            );
                          })}
                        </div>
                      </div>
                      <div style={{ textAlign: 'right' }}>
                        <p style={{ fontSize: 12, color: '#64748b', marginBottom: 4 }}>
                          Total outstanding
                        </p>
                        <p style={{
                          fontSize: 20, fontWeight: 700, color: '#dc2626',
                          marginBottom: 12
                        }}>
                          {'₹' + t.total_outstanding.toLocaleString()}
                        </p>
                        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
                          <button
                            onClick={() => handleSendReminder({
                              id: t.tenant_id, name: t.tenant_name
                            })}
                            disabled={actionLoading === 'remind-' + t.tenant_id}
                            style={{
                              background: '#fef9c3', color: '#854d0e',
                              padding: '6px 12px', borderRadius: 6,
                              fontSize: 12, border: '1px solid #fde68a',
                              cursor: 'pointer'
                            }}>
                            Remind
                          </button>
                          <button
                            onClick={() => handleViewTenantArrears(t)}
                            style={{
                              background: '#eff6ff', color: '#1e40af',
                              padding: '6px 12px', borderRadius: 6,
                              fontSize: 12, border: '1px solid #bfdbfe',
                              cursor: 'pointer'
                            }}>
                            Details
                          </button>
                          <button
                            onClick={() => {
                              setSelectedTenantForPayment({
                                id: t.tenant_id, name: t.tenant_name
                              });
                              setManualMonth(t.arrear_months[0]?.month || currentMonth);
                              setManualAmount(String(t.rent_amount));
                              setManualDate(new Date().toISOString().split('T')[0]);
                              setFormError('');
                              setShowManualPayment(true);
                            }}
                            style={{
                              background: '#dbeafe', color: '#1e40af',
                              padding: '6px 12px', borderRadius: 6,
                              fontSize: 12, border: '1px solid #bfdbfe',
                              cursor: 'pointer'
                            }}>
                            Record
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })
            )}
          </div>
        )}
      </div>

      {/* EDIT BUILDING MODAL */}
      {showEditBuilding && (
        <Modal title="Edit Building"
          onClose={() => { setShowEditBuilding(false); setFormError(''); }}
          onSave={handleUpdateBuilding} saveLabel="Save Changes"
          formError={formError} formLoading={formLoading}>
          <Field label="Building Name">
            <input type="text" placeholder="e.g. Hashvi Apartments"
              value={editBuildingName}
              onChange={e => setEditBuildingName(e.target.value)}
              style={inputStyle} />
          </Field>
          <Field label="Full Address">
            <textarea placeholder="Street, Area, City, Pincode"
              value={editBuildingAddress}
              onChange={e => setEditBuildingAddress(e.target.value)}
              rows={3} style={{ ...inputStyle, resize: 'vertical' }} />
          </Field>
          <Field label="UPI ID (optional)">
            <input type="text" placeholder="e.g. 9741400302@upi or name@okicici"
              value={editBuildingUpiId}
              onChange={e => setEditBuildingUpiId(e.target.value)}
              style={inputStyle} />
            <p style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>
              Used to generate tap-to-pay links in WhatsApp reminders.
            </p>
          </Field>
        </Modal>
      )}

      {/* DELETE BUILDING MODAL */}
      {showDeleteBuilding && (
        <Modal title="Delete Building"
          onClose={() => { setShowDeleteBuilding(false); setFormError(''); }}
          onSave={handleDeleteBuilding} saveLabel="Yes, Delete Building"
          formError={formError} formLoading={formLoading}>
          <div style={{
            background: '#fef2f2', border: '1px solid #fecaca',
            borderRadius: 10, padding: '14px 16px', marginBottom: 8
          }}>
            <p style={{ fontSize: 14, color: '#dc2626', fontWeight: 600, marginBottom: 6 }}>
              ⚠️ Are you sure you want to delete {selectedBuilding?.name}?
            </p>
            <p style={{ fontSize: 13, color: '#374151', lineHeight: 1.6 }}>
              This will permanently delete the building and all its units.
              <br />
              <strong>Note:</strong> Buildings with active tenants cannot be deleted.
              Move out all tenants first.
            </p>
          </div>
        </Modal>
      )}

      {/* ADD BUILDING MODAL */}
      {showAddBuilding && (
        <Modal title="Add Building"
          onClose={() => { setShowAddBuilding(false); resetForms(); }}
          onSave={handleAddBuilding} saveLabel="Save Building"
          formError={formError} formLoading={formLoading}>
          <Field label="Building Name">
            <input type="text" placeholder="e.g. Hashvi Apartments"
              value={buildingName} onChange={e => setBuildingName(e.target.value)} style={inputStyle} />
          </Field>
          <Field label="Full Address">
            <textarea placeholder="Street, Area, City, Pincode"
              value={buildingAddress} onChange={e => setBuildingAddress(e.target.value)}
              rows={3} style={{ ...inputStyle, resize: 'vertical' }} />
          </Field>
          <Field label="UPI ID (optional)">
            <input type="text" placeholder="e.g. 9741400302@upi or name@okicici"
              value={buildingUpiId} onChange={e => setBuildingUpiId(e.target.value)}
              style={inputStyle} />
            <p style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>
              Used to generate payment links in WhatsApp reminders. Tenants tap to pay directly via GPay/PhonePe.
            </p>
          </Field>
        </Modal>
      )}

      {/* ADD UNIT MODAL */}
      {showAddUnit && (
        <Modal title={'Add Unit — ' + selectedBuilding?.name}
          onClose={() => { setShowAddUnit(false); resetForms(); }}
          onSave={handleAddUnit} saveLabel="Save Unit"
          formError={formError} formLoading={formLoading}>

          {/* Unit Type Toggle */}
          <Field label="Unit Type">
            <div style={{ display: 'flex', gap: 10 }}>
              {['rental', 'lease'].map(type => (
                <button key={type} onClick={() => setUnitType(type)} style={{
                  flex: 1, padding: '10px',
                  background: unitType === type ? '#1f4e79' : '#f1f5f9',
                  color: unitType === type ? 'white' : '#64748b',
                  border: unitType === type ? 'none' : '1px solid #e2e8f0',
                  borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer'
                }}>
                  {type === 'rental' ? '🏠 Rental' : '📋 Lease'}
                </button>
              ))}
            </div>
            <p style={{ fontSize: 11, color: '#94a3b8', marginTop: 6 }}>
              {unitType === 'rental'
                ? 'Monthly rent collected from tenant'
                : 'One-time lease amount + monthly maintenance collected'}
            </p>
          </Field>

          <Field label="Unit Number">
            <input type="text" placeholder="e.g. 101, Room 1"
              value={unitNumber} onChange={e => setUnitNumber(e.target.value)} style={inputStyle} />
          </Field>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <Field label="Floor (optional)">
              <input type="number" placeholder="1"
                value={unitFloor} onChange={e => setUnitFloor(e.target.value)} style={inputStyle} />
            </Field>
            <Field label={unitType === 'lease' ? 'Monthly Maintenance (₹)' : 'Monthly Rent (₹)'}>
              <input type="number" placeholder={unitType === 'lease' ? '1500' : '7000'}
                value={unitRent} onChange={e => setUnitRent(e.target.value)} style={inputStyle} />
            </Field>
          </div>
          {unitType === 'lease' && (
            <Field label="Lease Amount (₹) — one-time">
              <input type="number" placeholder="500000"
                value={leaseAmount} onChange={e => setLeaseAmount(e.target.value)} style={inputStyle} />
            </Field>
          )}
        </Modal>
      )}

      {/* EDIT UNIT MODAL */}
      {showEditUnit && selectedUnitForEdit && (
        <Modal title={'Edit Unit ' + selectedUnitForEdit.unit_number}
          onClose={() => { setShowEditUnit(false); resetForms(); }}
          onSave={handleEditUnit} saveLabel="Update Unit"
          formError={formError} formLoading={formLoading}>
          <div style={{
            background: '#fef9c3', borderRadius: 8,
            padding: '10px 14px', marginBottom: 14,
            fontSize: 12, color: '#854d0e',
            border: '1px solid #fde68a'
          }}>
            If monthly amount changes, tenant will be notified on WhatsApp automatically.
          </div>

          {/* Unit Type Toggle */}
          <Field label="Unit Type">
            <div style={{ display: 'flex', gap: 10 }}>
              {['rental', 'lease'].map(type => (
                <button key={type} onClick={() => setUnitType(type)} style={{
                  flex: 1, padding: '10px',
                  background: unitType === type ? '#1f4e79' : '#f1f5f9',
                  color: unitType === type ? 'white' : '#64748b',
                  border: unitType === type ? 'none' : '1px solid #e2e8f0',
                  borderRadius: 8, fontSize: 14, fontWeight: 600, cursor: 'pointer'
                }}>
                  {type === 'rental' ? '🏠 Rental' : '📋 Lease'}
                </button>
              ))}
            </div>
          </Field>

          <Field label="Unit Number">
            <input type="text" value={unitNumber}
              onChange={e => setUnitNumber(e.target.value)} style={inputStyle} />
          </Field>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <Field label="Floor (optional)">
              <input type="number" value={unitFloor}
                onChange={e => setUnitFloor(e.target.value)} style={inputStyle} />
            </Field>
            <Field label={unitType === 'lease' ? 'Monthly Maintenance (₹)' : 'Monthly Rent (₹)'}>
              <input type="number" value={unitRent}
                onChange={e => setUnitRent(e.target.value)} style={inputStyle} />
            </Field>
          </div>
          {unitType === 'lease' && (
            <Field label="Lease Amount (₹) — one-time">
              <input type="number" placeholder="500000"
                value={leaseAmount} onChange={e => setLeaseAmount(e.target.value)} style={inputStyle} />
            </Field>
          )}
        </Modal>
      )}

      {/* ADD TENANT MODAL */}
      {showAddTenant && selectedUnitForTenant && (
        <Modal title={'Add Tenant — Unit ' + selectedUnitForTenant.unit_number}
          onClose={() => { setShowAddTenant(false); resetForms(); }}
          onSave={handleAddTenant} saveLabel="Save Tenant"
          formError={formError} formLoading={formLoading}>
          <Field label="Full Name">
            <input type="text" placeholder="As it should appear on receipts"
              value={tenantName} onChange={e => setTenantName(e.target.value)} style={inputStyle} />
          </Field>
          <Field label="WhatsApp Number">
            <input type="tel" placeholder="10-digit number"
              value={tenantPhone}
              onChange={e => setTenantPhone(e.target.value.replace(/\D/g, '').slice(0, 10))}
              style={inputStyle} />
          </Field>
          {/* NEW: Email field */}
          <Field label="Email (optional)">
            <input type="email" placeholder="tenant@email.com"
              value={tenantEmail}
              onChange={e => setTenantEmail(e.target.value)}
              style={inputStyle} />
          </Field>
          {/* NEW: Aadhaar last 4 field */}
          <Field label="Aadhaar Last 4 Digits (optional)">
            <input type="text" placeholder="e.g. 4521" maxLength={4}
              value={tenantAadhaar}
              onChange={e => setTenantAadhaar(e.target.value.replace(/\D/g, '').slice(0, 4))}
              style={inputStyle} />
          </Field>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <Field label="Security Deposit (₹)">
              <input type="number" placeholder="21000"
                value={tenantDeposit} onChange={e => setTenantDeposit(e.target.value)} style={inputStyle} />
            </Field>
            <Field label="Move-in Date">
              <input type="date" value={tenantMoveIn}
                onChange={e => setTenantMoveIn(e.target.value)} style={inputStyle} />
            </Field>
          </div>
        </Modal>
      )}

      {/* MANUAL PAYMENT MODAL */}
      {showManualPayment && selectedTenantForPayment && (
        <Modal title={'Record Payment — ' + selectedTenantForPayment.name}
          onClose={() => { setShowManualPayment(false); resetForms(); }}
          onSave={handleManualPayment} saveLabel="Record Payment"
          formError={formError} formLoading={formLoading}>
          <div style={{
            background: '#f0fdf4', borderRadius: 8,
            padding: '10px 14px', marginBottom: 16,
            fontSize: 13, color: '#166534',
            border: '1px solid #bbf7d0'
          }}>
            Tenant will receive receipt on WhatsApp after recording.
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <Field label="Amount (₹)">
              <input type="number" placeholder="7000"
                value={manualAmount} onChange={e => setManualAmount(e.target.value)} style={inputStyle} />
            </Field>
            <Field label="Payment Date">
              <input type="date" value={manualDate}
                onChange={e => setManualDate(e.target.value)} style={inputStyle} />
            </Field>
          </div>
          <Field label="Month (e.g. March-2026)">
            <input type="text" placeholder="March-2026"
              value={manualMonth} onChange={e => setManualMonth(e.target.value)} style={inputStyle} />
          </Field>
          <Field label="Payment Mode">
            <select value={manualMode} onChange={e => { setManualMode(e.target.value); setManualRef(''); }}
              style={{ ...inputStyle, background: 'white' }}>
              <option>Cash</option>
              <option>UPI</option>
              <option>Bank Transfer</option>
              <option>Cheque</option>
            </select>
          </Field>
          {manualMode !== 'Cash' && (
            <Field label={refLabel()}>
              <input type="text" placeholder={refPlaceholder()}
                value={manualRef} onChange={e => setManualRef(e.target.value)} style={inputStyle} />
            </Field>
          )}
        </Modal>
      )}

      {/* MOVE OUT MODAL */}
      {showMoveOut && selectedTenantForMoveOut && (
        <Modal
          title={'Move Out — ' + selectedTenantForMoveOut.name}
          onClose={() => { setShowMoveOut(false); resetForms(); }}
          onSave={handleMoveOut}
          saveLabel="Confirm Move Out"
          formError={formError}
          formLoading={formLoading}
        >
          <div style={{
            background: '#fff7ed', borderRadius: 8,
            padding: '12px 14px', marginBottom: 16,
            border: '1px solid #fed7aa'
          }}>
            <p style={{ color: '#c2410c', fontSize: 13, fontWeight: 600, marginBottom: 4 }}>
              This will mark {selectedTenantForMoveOut.name} as moved out
            </p>
            <p style={{ color: '#92400e', fontSize: 12 }}>
              Their payment history and receipts remain accessible. Unit will show as vacant.
            </p>
          </div>

          {selectedTenantForMoveOut.deposit_amount > 0 ? (
            <>
              <div style={{
                background: '#f8fafc', borderRadius: 8,
                padding: '12px 14px', marginBottom: 16,
                border: '1px solid #e2e8f0'
              }}>
                <p style={{ fontSize: 12, color: '#64748b', marginBottom: 4 }}>
                  Security Deposit on Record
                </p>
                <p style={{ fontSize: 20, fontWeight: 700, color: '#1e293b' }}>
                  {'₹' + selectedTenantForMoveOut.deposit_amount.toLocaleString()}
                </p>
              </div>

              <Field label="Deposit Status">
                <div style={{ display: 'flex', gap: 10 }}>
                  <button
                    onClick={() => setMoveOutDepositRefunded(false)}
                    style={{
                      flex: 1, padding: '10px',
                      background: !moveOutDepositRefunded ? '#fee2e2' : '#f1f5f9',
                      color: !moveOutDepositRefunded ? '#991b1b' : '#64748b',
                      border: !moveOutDepositRefunded ? '1.5px solid #fca5a5' : '1px solid #e2e8f0',
                      borderRadius: 8, fontSize: 13,
                      fontWeight: !moveOutDepositRefunded ? 600 : 400,
                      cursor: 'pointer'
                    }}>
                    Pending Refund
                  </button>
                  <button
                    onClick={() => setMoveOutDepositRefunded(true)}
                    style={{
                      flex: 1, padding: '10px',
                      background: moveOutDepositRefunded ? '#dcfce7' : '#f1f5f9',
                      color: moveOutDepositRefunded ? '#166534' : '#64748b',
                      border: moveOutDepositRefunded ? '1.5px solid #86efac' : '1px solid #e2e8f0',
                      borderRadius: 8, fontSize: 13,
                      fontWeight: moveOutDepositRefunded ? 600 : 400,
                      cursor: 'pointer'
                    }}>
                    Already Refunded
                  </button>
                </div>
              </Field>

              <Field label="Refund Amount (₹)">
                <input
                  type="number"
                  value={moveOutRefundAmount}
                  onChange={e => setMoveOutRefundAmount(e.target.value)}
                  style={inputStyle}
                />
              </Field>
            </>
          ) : (
            <p style={{ color: '#64748b', fontSize: 13, marginBottom: 8 }}>
              No security deposit on record for this tenant.
            </p>
          )}

          <p style={{ fontSize: 12, color: '#94a3b8', marginTop: 8 }}>
            A move-out confirmation will be sent to the tenant on WhatsApp.
          </p>
        </Modal>
      )}

      {/* EDIT TENANT MODAL */}
      {showEditTenant && selectedTenantForEdit && (
        <Modal title={'Edit Tenant — ' + selectedTenantForEdit.name}
          onClose={() => { setShowEditTenant(false); resetForms(); }}
          onSave={handleEditTenant} saveLabel="Update Tenant"
          formError={formError} formLoading={formLoading}>
          <Field label="Full Name">
            <input type="text" placeholder="As it should appear on receipts"
              value={tenantName} onChange={e => setTenantName(e.target.value)} style={inputStyle} />
          </Field>
          <Field label="WhatsApp Number">
            <input type="tel" placeholder="10-digit number"
              value={tenantPhone}
              onChange={e => setTenantPhone(e.target.value.replace(/\D/g, '').slice(0, 10))}
              style={inputStyle} />
          </Field>
          <Field label="Email (optional)">
            <input type="email" placeholder="tenant@email.com"
              value={tenantEmail} onChange={e => setTenantEmail(e.target.value)} style={inputStyle} />
          </Field>
          <Field label="Aadhaar Last 4 Digits (optional)">
            <input type="text" placeholder="e.g. 7890" maxLength={4}
              value={tenantAadhaar}
              onChange={e => setTenantAadhaar(e.target.value.replace(/\D/g, '').slice(0, 4))}
              style={inputStyle} />
          </Field>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
            <Field label="Security Deposit (₹)">
              <input type="number" placeholder="0"
                value={tenantDeposit} onChange={e => setTenantDeposit(e.target.value)} style={inputStyle} />
            </Field>
            <Field label="Move-in Date">
              <input type="date"
                value={tenantMoveIn} onChange={e => setTenantMoveIn(e.target.value)} style={inputStyle} />
            </Field>
          </div>
        </Modal>
      )}

      {/* DELETE TENANT CONFIRM MODAL */}
      {showDeleteTenant && selectedTenantForDelete && (
        <Modal title="Delete Tenant"
          onClose={() => { setShowDeleteTenant(false); resetForms(); }}
          onSave={handleDeleteTenant} saveLabel="Yes, Delete"
          formError={formError} formLoading={formLoading}>
          <div style={{
            background: '#fee2e2', borderRadius: 8,
            padding: '14px 16px', marginBottom: 8,
            fontSize: 14, color: '#991b1b',
            border: '1px solid #fca5a5'
          }}>
            <strong>Are you sure you want to delete {selectedTenantForDelete.name}?</strong>
            <p style={{ marginTop: 8, fontSize: 13 }}>
              This cannot be undone. Tenants with payment history cannot be deleted — use Move Out instead.
            </p>
          </div>
        </Modal>
      )}

      {/* DELETE UNIT CONFIRM MODAL */}
      {showDeleteUnit && selectedUnitForDelete && (
        <Modal title="Delete Unit"
          onClose={() => { setShowDeleteUnit(false); resetForms(); }}
          onSave={handleDeleteUnit} saveLabel="Yes, Delete"
          formError={formError} formLoading={formLoading}>
          <div style={{
            background: '#fee2e2', borderRadius: 8,
            padding: '14px 16px', marginBottom: 8,
            fontSize: 14, color: '#991b1b',
            border: '1px solid #fca5a5'
          }}>
            <strong>Are you sure you want to delete Unit {selectedUnitForDelete.unit_number}?</strong>
            <p style={{ marginTop: 8, fontSize: 13 }}>
              This cannot be undone. Units with tenant records cannot be deleted — remove all tenants first.
            </p>
          </div>
        </Modal>
      )}

      {/* KYC DOCUMENT MODAL */}
      {showKyc && selectedTenantForKyc && (
        <div style={{
          position: 'fixed', inset: 0,
          background: 'rgba(15,23,42,0.65)',
          backdropFilter: 'blur(4px)',
          display: 'flex', alignItems: 'center',
          justifyContent: 'center', zIndex: 1000, padding: 20
        }}>
          <div style={{
            background: '#fff', borderRadius: 20,
            width: '100%', maxWidth: 520,
            boxShadow: '0 32px 80px rgba(0,0,0,0.25)',
            maxHeight: '90vh', overflowY: 'auto'
          }}>
            {/* Header */}
            <div style={{
              background: 'linear-gradient(135deg, #1f4e79, #0d2d52)',
              padding: '22px 28px', borderRadius: '20px 20px 0 0',
              display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start'
            }}>
              <div>
                <p style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.55)', textTransform: 'uppercase', letterSpacing: 1.5, marginBottom: 4 }}>KYC Documents</p>
                <h3 style={{ fontSize: 20, fontWeight: 800, color: '#fff', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                  {selectedTenantForKyc.name}
                </h3>
                <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.55)', marginTop: 2 }}>
                  Documents auto-deleted 30 days after move-out
                </p>
              </div>
              <button onClick={() => { setShowKyc(false); setKycError(''); }} style={{
                background: 'rgba(255,255,255,0.15)', border: 'none',
                width: 32, height: 32, borderRadius: '50%',
                color: '#fff', fontSize: 16, cursor: 'pointer'
              }}>✕</button>
            </div>

            <div style={{ padding: '24px 28px' }}>
              {kycError && (
                <div style={{
                  background: '#fef2f2', border: '1px solid #fecaca',
                  borderRadius: 10, padding: '10px 14px',
                  color: '#dc2626', fontSize: 13, marginBottom: 16
                }}>⚠️ {kycError}</div>
              )}

              {/* ID Document Upload */}
              <div style={{
                background: '#f8fafc', border: '1px solid rgba(31,78,121,0.10)',
                borderRadius: 14, padding: '18px 20px', marginBottom: 14
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                  <div>
                    <p style={{ fontWeight: 700, fontSize: 14, color: '#0f172a', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                      🪪 ID Document
                    </p>
                    <p style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>Voter ID / Passport / Driving License · JPG, PNG or PDF · Max 5MB</p>
                  </div>
                  {kycUrls?.id_doc_url && (
                    <a href={kycUrls.id_doc_url} target="_blank" rel="noreferrer" style={{
                      background: '#f0fdf4', color: '#166534',
                      padding: '6px 12px', borderRadius: 8,
                      fontSize: 12, fontWeight: 600,
                      border: '1px solid #bbf7d0', textDecoration: 'none'
                    }}>👁 View</a>
                  )}
                </div>
                {/* Warning */}
                <div style={{
                  background: '#fff7ed', border: '1px solid #fed7aa',
                  borderRadius: 8, padding: '8px 14px', marginBottom: 10,
                  fontSize: 12, color: '#c2410c'
                }}>
                  ⚠️ Do not upload Aadhaar card. Upload Voter ID, Passport or Driving License only. By uploading you confirm this is not an Aadhaar card.
                </div>
                {kycUrls?.id_doc_url ? (
                  <div style={{
                    background: '#dcfce7', border: '1px solid #bbf7d0',
                    borderRadius: 8, padding: '8px 14px',
                    fontSize: 12, color: '#166534', fontWeight: 600, marginBottom: 10
                  }}>✅ ID Document uploaded</div>
                ) : (
                  <div style={{
                    background: '#fef9c3', border: '1px solid #fde68a',
                    borderRadius: 8, padding: '8px 14px',
                    fontSize: 12, color: '#854d0e', marginBottom: 10
                  }}>⚠️ Not uploaded yet</div>
                )}
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                  <label style={{
                    display: 'inline-block', background: '#1f4e79', color: '#fff',
                    padding: '8px 16px', borderRadius: 8, fontSize: 13, fontWeight: 600,
                    cursor: kycUploading ? 'not-allowed' : 'pointer', opacity: kycUploading ? 0.6 : 1
                  }}>
                    {kycUploading ? 'Uploading...' : kycUrls?.id_doc_url ? '🔄 Replace ID Document' : '⬆️ Upload ID Document'}
                    <input type="file" accept=".jpg,.jpeg,.png,.pdf" style={{ display: 'none' }}
                      disabled={kycUploading}
                      onChange={e => { if (e.target.files[0]) handleKycUpload(selectedTenantForKyc.id, e.target.files[0], 'id_doc'); }} />
                  </label>
                  {kycUrls?.id_doc_url && (
                    <button onClick={() => handleDeleteKyc(selectedTenantForKyc.id, 'id_doc')}
                      disabled={kycUploading}
                      style={{ background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 8, padding: '8px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                      🗑️ Delete
                    </button>
                  )}
                </div>
              </div>

              {/* Photo Upload */}
              <div style={{
                background: '#f8fafc', border: '1px solid rgba(31,78,121,0.10)',
                borderRadius: 14, padding: '18px 20px', marginBottom: 14
              }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                  <div>
                    <p style={{ fontWeight: 700, fontSize: 14, color: '#0f172a', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>
                      📸 Tenant Photo
                    </p>
                    <p style={{ fontSize: 12, color: '#64748b', marginTop: 2 }}>JPG or PNG · Max 5MB</p>
                  </div>
                  {kycUrls?.photo_url && (
                    <a href={kycUrls.photo_url} target="_blank" rel="noreferrer" style={{
                      background: '#f0fdf4', color: '#166634',
                      padding: '6px 12px', borderRadius: 8,
                      fontSize: 12, fontWeight: 600,
                      border: '1px solid #bbf7d0', textDecoration: 'none'
                    }}>👁 View</a>
                  )}
                </div>
                {kycUrls?.photo_url ? (
                  <div style={{
                    background: '#dcfce7', border: '1px solid #bbf7d0',
                    borderRadius: 8, padding: '8px 14px',
                    fontSize: 12, color: '#166534', fontWeight: 600, marginBottom: 10
                  }}>✅ Photo uploaded</div>
                ) : (
                  <div style={{
                    background: '#fef9c3', border: '1px solid #fde68a',
                    borderRadius: 8, padding: '8px 14px',
                    fontSize: 12, color: '#854d0e', marginBottom: 10
                  }}>⚠️ Not uploaded yet</div>
                )}
                <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                  <label style={{
                    display: 'inline-block', background: '#1f4e79', color: '#fff',
                    padding: '8px 16px', borderRadius: 8, fontSize: 13, fontWeight: 600,
                    cursor: kycUploading ? 'not-allowed' : 'pointer', opacity: kycUploading ? 0.6 : 1
                  }}>
                    {kycUploading ? 'Uploading...' : kycUrls?.photo_url ? '🔄 Replace Photo' : '⬆️ Upload Photo'}
                    <input type="file" accept=".jpg,.jpeg,.png" style={{ display: 'none' }}
                      disabled={kycUploading}
                      onChange={e => { if (e.target.files[0]) handleKycUpload(selectedTenantForKyc.id, e.target.files[0], 'photo'); }} />
                  </label>
                  {kycUrls?.photo_url && (
                    <button onClick={() => handleDeleteKyc(selectedTenantForKyc.id, 'photo')}
                      disabled={kycUploading}
                      style={{ background: '#fef2f2', color: '#dc2626', border: '1px solid #fecaca', borderRadius: 8, padding: '8px 12px', fontSize: 12, fontWeight: 600, cursor: 'pointer' }}>
                      🗑️ Delete
                    </button>
                  )}
                </div>
              </div>

              {kycUrls?.kyc_uploaded_at && (
                <p style={{ fontSize: 11, color: '#94a3b8', textAlign: 'center', marginTop: 12 }}>
                  Last uploaded: {new Date(kycUrls.kyc_uploaded_at).toLocaleDateString('en-IN')}
                </p>
              )}
            </div>
          </div>
        </div>
      )}

      {/* PAYMENT HISTORY MODAL */}
      {showHistory && selectedTenantForHistory && (
        <div style={{
          position: 'fixed', inset: 0,
          background: 'rgba(15,23,42,0.65)',
          backdropFilter: 'blur(4px)',
          display: 'flex', alignItems: 'center',
          justifyContent: 'center', zIndex: 1000, padding: 20
        }}>
          <div style={{
            background: '#f8fafc', borderRadius: 20,
            width: '100%', maxWidth: 640,
            boxShadow: '0 32px 80px rgba(0,0,0,0.25)',
            maxHeight: '90vh', overflowY: 'auto',
            display: 'flex', flexDirection: 'column'
          }}>
            {/* Header */}
            <div style={{
              background: 'linear-gradient(135deg, #1f4e79, #0d2d52)',
              padding: '24px 28px', borderRadius: '20px 20px 0 0',
              position: 'relative'
            }}>
              <button onClick={() => setShowHistory(false)} style={{
                position: 'absolute', top: 16, right: 16,
                background: 'rgba(255,255,255,0.15)', border: 'none',
                width: 32, height: 32, borderRadius: '50%',
                color: '#fff', fontSize: 16, cursor: 'pointer',
                display: 'flex', alignItems: 'center', justifyContent: 'center'
              }}>✕</button>
              <p style={{ fontSize: 11, fontWeight: 700, color: 'rgba(255,255,255,0.55)', textTransform: 'uppercase', letterSpacing: 1.5, marginBottom: 4 }}>Tenant Ledger</p>
              <h3 style={{ fontSize: 22, fontWeight: 800, color: '#fff', fontFamily: 'Plus Jakarta Sans, sans-serif', marginBottom: 2 }}>
                {selectedTenantForHistory.name}
              </h3>
              <p style={{ fontSize: 13, color: 'rgba(255,255,255,0.60)' }}>
                {selectedTenantForHistory.unit_number ? `Unit ${selectedTenantForHistory.unit_number}` : ''} · {selectedTenantForHistory.phone}
              </p>
              {/* Summary stats */}
              <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12, marginTop: 20 }}>
                {[
                  { label: 'Total Paid', value: '₹' + paymentHistory.filter(p => ['paid','auto_approved'].includes(p.status)).reduce((a,p) => a + (p.amount_paid || p.amount), 0).toLocaleString() },
                  { label: 'Payments', value: paymentHistory.filter(p => ['paid','auto_approved'].includes(p.status)).length },
                  { label: 'Pending', value: paymentHistory.filter(p => p.status === 'pending').length },
                ].map((s,i) => (
                  <div key={i} style={{ background: 'rgba(255,255,255,0.08)', borderRadius: 10, padding: '10px 14px' }}>
                    <p style={{ fontSize: 10, color: 'rgba(255,255,255,0.50)', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 4 }}>{s.label}</p>
                    <p style={{ fontSize: 20, fontWeight: 800, color: '#fff', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>{s.value}</p>
                  </div>
                ))}
              </div>
            </div>

            {/* Payment Records */}
            <div style={{ padding: '20px 28px' }}>
              <p style={{ fontSize: 12, fontWeight: 700, color: '#94a3b8', textTransform: 'uppercase', letterSpacing: 1, marginBottom: 14 }}>
                Payment History
              </p>
              {paymentHistory.length === 0 ? (
                <div style={{ textAlign: 'center', padding: '32px 0', color: '#94a3b8' }}>
                  <p style={{ fontSize: 32, marginBottom: 8 }}>📭</p>
                  <p>No payments recorded yet</p>
                </div>
              ) : (
                <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
                  {paymentHistory.map(function(p) {
                    const statusConfig = {
                      paid:         { bg: '#dcfce7', color: '#166534', label: 'Paid' },
                      auto_approved:{ bg: '#d1fae5', color: '#065f46', label: 'Auto Approved' },
                      pending:      { bg: '#fef9c3', color: '#854d0e', label: 'Pending' },
                      partial:      { bg: '#dbeafe', color: '#1e40af', label: 'Partial' },
                      rejected:     { bg: '#fee2e2', color: '#991b1b', label: 'Rejected' },
                    }[p.status] || { bg: '#f1f5f9', color: '#64748b', label: p.status };

                    const isPaid = ['paid','auto_approved'].includes(p.status);

                    return (
                      <div key={p.id} style={{
                        background: '#fff',
                        border: '1px solid rgba(31,78,121,0.08)',
                        borderRadius: 12, padding: '14px 18px',
                        display: 'flex', justifyContent: 'space-between',
                        alignItems: 'center', gap: 12,
                        boxShadow: '0 1px 4px rgba(31,78,121,0.04)'
                      }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                            <p style={{ fontWeight: 700, fontSize: 14, color: '#0f172a', fontFamily: 'Plus Jakarta Sans, sans-serif' }}>{p.month}</p>
                            <span style={{
                              background: statusConfig.bg, color: statusConfig.color,
                              padding: '2px 8px', borderRadius: 20,
                              fontSize: 10, fontWeight: 700, textTransform: 'uppercase'
                            }}>{statusConfig.label}</span>
                          </div>
                          <p style={{ fontSize: 13, color: '#374151', fontWeight: 600 }}>
                            ₹{(p.amount_paid || p.amount || 0).toLocaleString()}
                            {p.amount_balance > 0 && <span style={{ color: '#ef4444', fontWeight: 400, fontSize: 12 }}> · Balance ₹{p.amount_balance.toLocaleString()}</span>}
                          </p>
                          <div style={{ display: 'flex', gap: 12, marginTop: 4, flexWrap: 'wrap' }}>
                            {p.payment_date && <p style={{ fontSize: 11, color: '#94a3b8' }}>📅 {p.payment_date}</p>}
                            {p.payment_mode && <p style={{ fontSize: 11, color: '#94a3b8' }}>💳 {p.payment_mode}</p>}
                            {p.upi_transaction_id && <p style={{ fontSize: 11, color: '#94a3b8' }}>🔖 {p.upi_transaction_id}</p>}
                          </div>
                          {p.receipt_number && (
                            <p style={{ fontSize: 11, color: '#94a3b8', marginTop: 2 }}>🧾 {p.receipt_number}</p>
                          )}
                        </div>
                        {isPaid && p.receipt_number && (
                          <a href={process.env.REACT_APP_API_URL + '/receipt/' + p.id}
                            target="_blank" rel="noreferrer"
                            style={{
                              background: '#f0f7ff', color: '#1f4e79',
                              padding: '7px 14px', borderRadius: 8,
                              fontSize: 12, fontWeight: 600,
                              border: '1px solid rgba(31,78,121,0.15)',
                              textDecoration: 'none', whiteSpace: 'nowrap',
                              flexShrink: 0
                            }}>
                            📄 Receipt
                          </a>
                        )}
                      </div>
                    );
                  })}
                </div>
              )}
            </div>
          </div>
        </div>
      )}

      {/* PRO-RATA MODAL */}
      {showProrataModal && prorataData && (
        <div style={{
          position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.4)',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
          zIndex: 1000, padding: 20
        }}>
          <div style={{
            background: 'white', borderRadius: 12, padding: 28,
            width: '100%', maxWidth: 440,
            boxShadow: '0 20px 60px rgba(0,0,0,0.2)', maxHeight: '90vh', overflowY: 'auto'
          }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h3 style={{ fontSize: 17, fontWeight: 600 }}>Pro-rata Rent · {prorataData.tenant.name}</h3>
              <button onClick={() => { setShowProrataModal(false); resetForms(); }}
                style={{ background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#94a3b8' }}>✕</button>
            </div>

            <div style={{
              background: '#fffbeb', border: '1px solid #fde68a',
              borderRadius: 8, padding: '12px 14px', marginBottom: 16,
              fontSize: 13, color: '#92400e'
            }}>
              {prorataData.month} pro-rata: {prorataData.days} days
              ({prorataData.tenant.move_in_date} – end of month) at
              ₹{prorataData.unit.rent_amount.toLocaleString()}/month = <strong>₹{prorataData.amount.toLocaleString()}</strong>
            </div>

            <Field label="Amount (₹) — editable">
              <input type="number" value={manualAmount}
                onChange={e => setManualAmount(e.target.value)} style={inputStyle} />
              <p style={{ fontSize: 11, color: '#94a3b8', marginTop: 4 }}>
                Adjust if your agreed amount differs from the calculated amount.
              </p>
            </Field>

            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              <Field label="Payment Date">
                <input type="date" value={manualDate}
                  onChange={e => setManualDate(e.target.value)} style={inputStyle} />
              </Field>
              <Field label="Month">
                <input type="text" value={manualMonth}
                  onChange={e => setManualMonth(e.target.value)} style={inputStyle} />
              </Field>
            </div>

            <Field label="Payment Mode">
              <select value={manualMode}
                onChange={e => { setManualMode(e.target.value); setManualRef(''); }}
                style={{ ...inputStyle, background: 'white' }}>
                <option>Cash</option>
                <option>UPI</option>
                <option>Bank Transfer</option>
                <option>Cheque</option>
              </select>
            </Field>

            {manualMode !== 'Cash' && (
              <Field label={refLabel()}>
                <input type="text" placeholder={refPlaceholder()}
                  value={manualRef} onChange={e => setManualRef(e.target.value)} style={inputStyle} />
              </Field>
            )}

            {formError && (
              <p style={{ color: '#dc2626', fontSize: 13, marginTop: 8 }}>{formError}</p>
            )}

            <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
              <button onClick={() => { setShowProrataModal(false); resetForms(); }} style={{
                flex: 1, padding: 11, background: '#f1f5f9',
                border: 'none', borderRadius: 8, fontSize: 14, cursor: 'pointer', color: '#64748b'
              }}>Cancel</button>
              <button onClick={handleSaveProrata} disabled={formLoading} style={{
                flex: 2, padding: 11,
                background: formLoading ? '#cbd5e1' : '#1f4e79',
                color: 'white', border: 'none', borderRadius: 8,
                fontSize: 14, fontWeight: 600, cursor: 'pointer'
              }}>
                {formLoading ? 'Saving...' : 'Save & send WhatsApp receipt'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* DEPOSIT PAYMENT MODAL */}
      {showDepositModal && selectedTenantForDeposit && (
        <div style={{
          position: 'fixed', inset: 0,
          background: 'rgba(0,0,0,0.4)',
          display: 'flex', alignItems: 'center',
          justifyContent: 'center', zIndex: 1000, padding: 20
        }}>
          <div style={{
            background: 'white', borderRadius: 12,
            padding: 28, width: '100%', maxWidth: 500,
            boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
            maxHeight: '90vh', overflowY: 'auto'
          }}>
            {/* Header */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 20 }}>
              <h3 style={{ fontSize: 17, fontWeight: 600 }}>
                {selectedTenantForDeposit.name} — Deposit
              </h3>
              <button onClick={() => { setShowDepositModal(false); resetForms(); }} style={{
                background: 'none', border: 'none', fontSize: 20, cursor: 'pointer', color: '#94a3b8'
              }}>✕</button>
            </div>

            {/* Summary bar */}
            {depositHistory && (
              <div style={{
                background: depositHistory.fully_paid ? '#f0fdf4' : '#fdf4ff',
                border: '1px solid ' + (depositHistory.fully_paid ? '#86efac' : '#e9d5ff'),
                borderRadius: 10, padding: '14px 18px', marginBottom: 20,
                display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 12
              }}>
                {[
                  { label: 'Total Deposit', value: '₹' + (depositHistory.total_agreed || 0).toLocaleString(), color: '#1e293b' },
                  { label: 'Collected', value: '₹' + (depositHistory.total_collected || 0).toLocaleString(), color: '#16a34a' },
                  { label: 'Balance Due', value: '₹' + (depositHistory.balance_remaining || 0).toLocaleString(), color: depositHistory.fully_paid ? '#16a34a' : '#7e22ce' },
                ].map((s, i) => (
                  <div key={i} style={{ textAlign: 'center' }}>
                    <p style={{ fontSize: 11, color: '#64748b', marginBottom: 4 }}>{s.label}</p>
                    <p style={{ fontSize: 16, fontWeight: 700, color: s.color }}>{s.value}</p>
                  </div>
                ))}
              </div>
            )}
            {depositHistory && depositHistory.fully_paid && (
              <div style={{
                background: '#f0fdf4', border: '1px solid #86efac',
                borderRadius: 8, padding: '10px 14px', marginBottom: 16,
                color: '#166534', fontSize: 13, fontWeight: 500, textAlign: 'center'
              }}>
                ✓ Deposit fully collected
              </div>
            )}

            {/* Record new instalment */}
            {depositHistory && !depositHistory.fully_paid && (
              <div style={{
                background: '#f8fafc', borderRadius: 8,
                border: '1px solid #e2e8f0', padding: 16, marginBottom: 20
              }}>
                <p style={{ fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 12 }}>
                  Record Instalment
                  <span style={{ marginLeft: 8, fontWeight: 400, color: '#94a3b8', fontSize: 12 }}>
                    Balance: ₹{(depositHistory.balance_remaining || 0).toLocaleString()}
                  </span>
                </p>
                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
                  <div>
                    <label style={{ fontSize: 12, fontWeight: 500, color: '#374151', display: 'block', marginBottom: 4 }}>Amount (₹)</label>
                    <input type="number" placeholder="e.g. 5000"
                      value={depositInstalment}
                      onChange={e => setDepositInstalment(e.target.value)}
                      style={{ width: '100%', padding: '9px 11px', border: '1.5px solid #e2e8f0', borderRadius: 7, fontSize: 14, boxSizing: 'border-box' }} />
                  </div>
                  <div>
                    <label style={{ fontSize: 12, fontWeight: 500, color: '#374151', display: 'block', marginBottom: 4 }}>Date</label>
                    <input type="date"
                      value={depositDate}
                      onChange={e => setDepositDate(e.target.value)}
                      style={{ width: '100%', padding: '9px 11px', border: '1.5px solid #e2e8f0', borderRadius: 7, fontSize: 14, boxSizing: 'border-box' }} />
                  </div>
                </div>
                <div style={{ marginBottom: 10 }}>
                  <label style={{ fontSize: 12, fontWeight: 500, color: '#374151', display: 'block', marginBottom: 4 }}>Mode</label>
                  <select value={depositMode} onChange={e => setDepositMode(e.target.value)}
                    style={{ width: '100%', padding: '9px 11px', border: '1.5px solid #e2e8f0', borderRadius: 7, fontSize: 14, background: 'white', boxSizing: 'border-box' }}>
                    {['Cash', 'UPI', 'Bank Transfer', 'Cheque'].map(m => <option key={m}>{m}</option>)}
                  </select>
                </div>
                {depositMode !== 'Cash' && (
                  <div style={{ marginBottom: 10 }}>
                    <label style={{ fontSize: 12, fontWeight: 500, color: '#374151', display: 'block', marginBottom: 4 }}>
                      {depositMode === 'UPI' ? 'UPI Transaction ID' : depositMode === 'Cheque' ? 'Cheque Number' : 'UTR / Reference'}
                    </label>
                    <input type="text"
                      value={depositRef}
                      onChange={e => setDepositRef(e.target.value)}
                      placeholder={depositMode === 'UPI' ? 'e.g. 606711011862' : ''}
                      style={{ width: '100%', padding: '9px 11px', border: '1.5px solid #e2e8f0', borderRadius: 7, fontSize: 14, boxSizing: 'border-box' }} />
                  </div>
                )}
                <div style={{ marginBottom: 12 }}>
                  <label style={{ fontSize: 12, fontWeight: 500, color: '#374151', display: 'block', marginBottom: 4 }}>Note (optional)</label>
                  <input type="text"
                    value={depositNote}
                    onChange={e => setDepositNote(e.target.value)}
                    placeholder="e.g. First instalment"
                    style={{ width: '100%', padding: '9px 11px', border: '1.5px solid #e2e8f0', borderRadius: 7, fontSize: 14, boxSizing: 'border-box' }} />
                </div>
                {depositError && (
                  <p style={{ color: '#dc2626', fontSize: 13, marginBottom: 10 }}>{depositError}</p>
                )}
                <button
                  onClick={handleRecordDeposit}
                  disabled={depositLoading}
                  style={{
                    width: '100%', padding: 11,
                    background: depositLoading ? '#a78bfa' : '#7c3aed',
                    color: 'white', border: 'none', borderRadius: 8,
                    fontSize: 14, fontWeight: 600, cursor: 'pointer'
                  }}>
                  {depositLoading ? 'Saving...' : 'Record Instalment'}
                </button>
              </div>
            )}

            {/* Instalment history */}
            {depositHistory && depositHistory.instalments.length > 0 && (
              <div>
                <p style={{ fontSize: 13, fontWeight: 600, color: '#374151', marginBottom: 10 }}>
                  Payment History ({depositHistory.instalments.length})
                </p>
                {depositHistory.instalments.map(function(d) {
                  return (
                    <div key={d.id} style={{
                      display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start',
                      padding: '10px 0', borderBottom: '1px solid #f1f5f9'
                    }}>
                      <div>
                        <p style={{ fontWeight: 600, fontSize: 14, color: '#16a34a' }}>
                          ₹{d.amount_paid.toLocaleString()}
                        </p>
                        <p style={{ color: '#64748b', fontSize: 12, marginTop: 2 }}>
                          {d.payment_date} · {d.payment_mode}
                          {d.reference ? ' · Ref: ' + d.reference : ''}
                        </p>
                        {d.note && (
                          <p style={{ color: '#94a3b8', fontSize: 12, marginTop: 1 }}>{d.note}</p>
                        )}
                      </div>
                      <button
                        onClick={() => handleDeleteDepositPayment(d.id)}
                        style={{
                          background: 'none', border: 'none',
                          color: '#cbd5e1', fontSize: 16, cursor: 'pointer',
                          padding: '2px 6px'
                        }}
                        title="Remove this entry">×</button>
                    </div>
                  );
                })}
              </div>
            )}

            {depositHistory && depositHistory.instalments.length === 0 && (
              <p style={{ color: '#94a3b8', fontSize: 13, textAlign: 'center', padding: '12px 0' }}>
                No deposit payments recorded yet.
              </p>
            )}

            <button onClick={() => { setShowDepositModal(false); resetForms(); }} style={{
              width: '100%', padding: 11, background: '#f1f5f9',
              border: 'none', borderRadius: 8, fontSize: 14,
              cursor: 'pointer', color: '#64748b', marginTop: 16
            }}>Close</button>
          </div>
        </div>
      )}

      {/* TENANT ARREARS DETAIL MODAL */}
      {showTenantArrears && tenantArrearsDetail && (
        <div style={{
          position: 'fixed', inset: 0,
          background: 'rgba(0,0,0,0.4)',
          display: 'flex', alignItems: 'center',
          justifyContent: 'center', zIndex: 1000, padding: 20
        }}>
          <div style={{
            background: 'white', borderRadius: 12,
            padding: 28, width: '100%', maxWidth: 460,
            boxShadow: '0 20px 60px rgba(0,0,0,0.2)',
            maxHeight: '80vh', overflowY: 'auto'
          }}>
            <div style={{
              display: 'flex', justifyContent: 'space-between',
              alignItems: 'center', marginBottom: 20
            }}>
              <h3 style={{ fontSize: 17, fontWeight: 600 }}>
                {tenantArrearsDetail.tenant_name} — Arrears
              </h3>
              <button onClick={() => setShowTenantArrears(false)} style={{
                background: 'none', border: 'none',
                fontSize: 20, cursor: 'pointer', color: '#94a3b8'
              }}>✕</button>
            </div>

            <div style={{
              background: '#fef3c7', borderRadius: 8,
              padding: '12px 16px', marginBottom: 20,
              border: '1px solid #fde68a'
            }}>
              <p style={{ fontSize: 12, color: '#92400e', marginBottom: 2 }}>
                Total Outstanding
              </p>
              <p style={{ fontSize: 22, fontWeight: 700, color: '#92400e' }}>
                {'₹' + tenantArrearsDetail.total_outstanding.toLocaleString()}
              </p>
              <p style={{ fontSize: 12, color: '#92400e', marginTop: 4 }}>
                {tenantArrearsDetail.months_overdue + ' month(s) unpaid · Unit ' +
                  tenantArrearsDetail.unit_number}
              </p>
            </div>

            {tenantArrearsDetail.arrears.map(function(a) {
              const isUpcoming = a.status === 'upcoming';
              const isOverdue = !isUpcoming && a.days_overdue > 30;
              return (
                <div key={a.month} style={{
                  display: 'flex', justifyContent: 'space-between',
                  alignItems: 'center',
                  padding: '12px 0', borderBottom: '1px solid #f1f5f9'
                }}>
                  <div>
                    <p style={{ fontWeight: 500, fontSize: 14 }}>{a.month}</p>
                    <p style={{ color: '#94a3b8', fontSize: 12, marginTop: 2 }}>
                      {isUpcoming
                        ? 'Upcoming — due by 10th'
                        : isOverdue
                          ? a.days_overdue + ' days overdue'
                          : 'Due this month'}
                    </p>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
                    <p style={{ fontWeight: 600, color: isUpcoming ? '#1e40af' : '#dc2626' }}>
                      {'₹' + a.amount.toLocaleString()}
                    </p>
                    <span style={{
                      background: isUpcoming ? '#dbeafe' : isOverdue ? '#fee2e2' : '#fef9c3',
                      color: isUpcoming ? '#1e40af' : isOverdue ? '#991b1b' : '#854d0e',
                      padding: '3px 8px', borderRadius: 20,
                      fontSize: 11, fontWeight: 500
                    }}>
                      {isUpcoming ? 'UPCOMING' : isOverdue ? 'OVERDUE' : 'DUE'}
                    </span>
                  </div>
                </div>
              );
            })}

            <button
              onClick={() => setShowTenantArrears(false)}
              style={{
                width: '100%', padding: 11,
                background: '#f1f5f9', border: 'none',
                borderRadius: 8, fontSize: 14,
                cursor: 'pointer', color: '#64748b',
                marginTop: 20
              }}>
              Close
            </button>
          </div>
        </div>
      )}

      {/* DOWNLOAD REPORT MODAL */}
      {/* ── AGREEMENT GENERATOR TAB ── */}
      {activeTab === 'agreements' && (
        <AgreementGenerator 
          buildings={buildings}
          units={units}
          user={user}
        />
      )}

      {/* ── MY AGREEMENTS TAB (v1.6.0) ── */}
      {activeTab === 'my-agreements' && (
        <MyAgreements />
      )}

      {/* ── DOWNLOAD REPORT MODAL ── */}
      {showDownloadModal && (
        <div style={{
          position: 'fixed', inset: 0,
          background: 'rgba(0,0,0,0.4)',
          display: 'flex', alignItems: 'center',
          justifyContent: 'center', zIndex: 1000, padding: 20
        }}>
          <div style={{
            background: 'white', borderRadius: 12,
            padding: 0, width: '100%', maxWidth: 480,
            boxShadow: '0 20px 60px rgba(0,0,0,0.2)'
          }}>
            {/* Header */}
            <div style={{ padding: '20px 24px', borderBottom: '1px solid #e2e8f0' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <div>
                  <h3 style={{ fontSize: 17, fontWeight: 600, margin: 0 }}>Download Rent Collection Report</h3>
                  <p style={{ fontSize: 13, color: '#64748b', margin: '4px 0 0' }}>Select report type and date range</p>
                </div>
                <button onClick={() => setShowDownloadModal(false)} style={{
                  background: 'none', border: 'none',
                  fontSize: 20, cursor: 'pointer', color: '#94a3b8'
                }}>✕</button>
              </div>
            </div>

            {/* Options */}
            <div style={{ padding: '24px' }}>
              
              {/* Option 1: Specific Month */}
              <label style={{ display: 'block', marginBottom: 20, cursor: 'pointer' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  <input 
                    type="radio" 
                    name="downloadType" 
                    checked={downloadType === 'month'}
                    onChange={() => setDownloadType('month')}
                    style={{ marginTop: 2 }}
                  />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 500, fontSize: 14, marginBottom: 8 }}>Specific month</div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8 }}>
                      <select 
                        value={downloadMonth}
                        onChange={e => setDownloadMonth(e.target.value)}
                        disabled={downloadType !== 'month'}
                        style={{
                          padding: '8px 10px', borderRadius: 8, border: '1px solid #e2e8f0',
                          fontSize: 13, background: 'white', cursor: 'pointer'
                        }}>
                        <option value="01">January</option>
                        <option value="02">February</option>
                        <option value="03">March</option>
                        <option value="04">April</option>
                        <option value="05">May</option>
                        <option value="06">June</option>
                        <option value="07">July</option>
                        <option value="08">August</option>
                        <option value="09">September</option>
                        <option value="10">October</option>
                        <option value="11">November</option>
                        <option value="12">December</option>
                      </select>
                      <select 
                        value={downloadYear}
                        onChange={e => setDownloadYear(e.target.value)}
                        disabled={downloadType !== 'month'}
                        style={{
                          padding: '8px 10px', borderRadius: 8, border: '1px solid #e2e8f0',
                          fontSize: 13, background: 'white', cursor: 'pointer'
                        }}>
                        <option value="2024">2024</option>
                        <option value="2025">2025</option>
                        <option value="2026">2026</option>
                        <option value="2027">2027</option>
                      </select>
                    </div>
                  </div>
                </div>
              </label>

              {/* Option 2: Full Year */}
              <label style={{ display: 'block', marginBottom: 20, cursor: 'pointer' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  <input 
                    type="radio" 
                    name="downloadType" 
                    checked={downloadType === 'year'}
                    onChange={() => setDownloadType('year')}
                    style={{ marginTop: 2 }}
                  />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 500, fontSize: 14, marginBottom: 8 }}>Full year report</div>
                    <select 
                      value={downloadYear}
                      onChange={e => setDownloadYear(e.target.value)}
                      disabled={downloadType !== 'year'}
                      style={{
                        padding: '8px 10px', borderRadius: 8, border: '1px solid #e2e8f0',
                        fontSize: 13, background: 'white', cursor: 'pointer', width: '100%'
                      }}>
                      <option value="2024">2024</option>
                      <option value="2025">2025</option>
                      <option value="2026">2026</option>
                      <option value="2027">2027</option>
                    </select>
                  </div>
                </div>
              </label>

              {/* Option 3: Date Range */}
              <label style={{ display: 'block', cursor: 'pointer' }}>
                <div style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                  <input 
                    type="radio" 
                    name="downloadType" 
                    checked={downloadType === 'range'}
                    onChange={() => setDownloadType('range')}
                    style={{ marginTop: 2 }}
                  />
                  <div style={{ flex: 1 }}>
                    <div style={{ fontWeight: 500, fontSize: 14, marginBottom: 8 }}>Custom date range</div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr auto 1fr', gap: 8, alignItems: 'center' }}>
                      <input 
                        type="month" 
                        value={downloadFromMonth}
                        onChange={e => setDownloadFromMonth(e.target.value)}
                        disabled={downloadType !== 'range'}
                        style={{
                          padding: '8px 10px', borderRadius: 8, border: '1px solid #e2e8f0',
                          fontSize: 13, background: 'white', cursor: 'pointer'
                        }}
                      />
                      <span style={{ fontSize: 13, color: '#64748b' }}>to</span>
                      <input 
                        type="month" 
                        value={downloadToMonth}
                        onChange={e => setDownloadToMonth(e.target.value)}
                        disabled={downloadType !== 'range'}
                        style={{
                          padding: '8px 10px', borderRadius: 8, border: '1px solid #e2e8f0',
                          fontSize: 13, background: 'white', cursor: 'pointer'
                        }}
                      />
                    </div>
                  </div>
                </div>
              </label>

            </div>

            {/* Footer */}
            <div style={{ padding: '16px 24px', borderTop: '1px solid #e2e8f0', display: 'flex', gap: 10 }}>
              <button onClick={() => setShowDownloadModal(false)} style={{
                flex: 1, padding: 11, background: '#f1f5f9',
                border: 'none', borderRadius: 8, fontSize: 14,
                cursor: 'pointer', color: '#64748b'
              }}>Cancel</button>
              <button onClick={executeDownload} style={{
                flex: 2, padding: 11, background: '#1f4e79',
                color: 'white', border: 'none', borderRadius: 8,
                fontSize: 14, fontWeight: 600, cursor: 'pointer'
              }}>Download</button>
            </div>

          </div>
        </div>
      )}

      </div>
    </div>
  );
}